(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib-js-ir.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib-js-ir.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib-js-ir'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-kds'. Its dependency 'kotlin-kotlin-stdlib-js-ir' was not found. Please, check whether 'kotlin-kotlin-stdlib-js-ir' is loaded prior to 'korge-root-kds'.");
    }
    root['korge-root-kds'] = factory(typeof this['korge-root-kds'] === 'undefined' ? {} : this['korge-root-kds'], this['kotlin-kotlin-stdlib-js-ir']);
  }
}(this, function (_, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var log2 = Math.log2;
  var protoOf = kotlin_kotlin.$_$.f9;
  var objectMeta = kotlin_kotlin.$_$.e9;
  var VOID = kotlin_kotlin.$_$.nd;
  var setMetadataFor = kotlin_kotlin.$_$.g9;
  var contentEquals = kotlin_kotlin.$_$.s3;
  var contentHashCode = kotlin_kotlin.$_$.t3;
  var intArrayIterator = kotlin_kotlin.$_$.l8;
  var classMeta = kotlin_kotlin.$_$.a8;
  var contentEquals_0 = kotlin_kotlin.$_$.r3;
  var contentHashCode_0 = kotlin_kotlin.$_$.v3;
  var floatArrayIterator = kotlin_kotlin.$_$.f8;
  var Unit_getInstance = kotlin_kotlin.$_$.t2;
  var println = kotlin_kotlin.$_$.s7;
  var toString = kotlin_kotlin.$_$.k9;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.f1;
  var Long = kotlin_kotlin.$_$.kc;
  var toLong = kotlin_kotlin.$_$.i9;
  var reverse = kotlin_kotlin.$_$.x5;
  var copyOf = kotlin_kotlin.$_$.b4;
  var THROW_CCE = kotlin_kotlin.$_$.pc;
  var isDoubleArray = kotlin_kotlin.$_$.r8;
  var IndexOutOfBoundsException_init_$Create$ = kotlin_kotlin.$_$.h1;
  var take = kotlin_kotlin.$_$.f6;
  var equals = kotlin_kotlin.$_$.c8;
  var List = kotlin_kotlin.$_$.z2;
  var isInterface = kotlin_kotlin.$_$.u8;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.w;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.r1;
  var Collection = kotlin_kotlin.$_$.x2;
  var objectCreate = kotlin_kotlin.$_$.d9;
  var copyOf_0 = kotlin_kotlin.$_$.c4;
  var isFloatArray = kotlin_kotlin.$_$.s8;
  var take_0 = kotlin_kotlin.$_$.d6;
  var isIntArray = kotlin_kotlin.$_$.t8;
  var copyOf_1 = kotlin_kotlin.$_$.e4;
  var take_1 = kotlin_kotlin.$_$.e6;
  var compareTo = kotlin_kotlin.$_$.b8;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.o;
  var isObject = kotlin_kotlin.$_$.w8;
  var MutableMap = kotlin_kotlin.$_$.d3;
  var hashCode = kotlin_kotlin.$_$.k8;
  var fillArrayVal = kotlin_kotlin.$_$.e8;
  var isArray = kotlin_kotlin.$_$.n8;
  var toList = kotlin_kotlin.$_$.k6;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.l3;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.h;
  var to = kotlin_kotlin.$_$.md;
  var Map_0 = kotlin_kotlin.$_$.a3;
  var StringBuilder_init_$Create$_0 = kotlin_kotlin.$_$.x;
  var MutableIterable = kotlin_kotlin.$_$.b3;
  var addAll = kotlin_kotlin.$_$.f3;
  var MutableList = kotlin_kotlin.$_$.c3;
  var interfaceMeta = kotlin_kotlin.$_$.m8;
  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.n;
  var AbstractMutableSet = kotlin_kotlin.$_$.v2;
  var IndexOutOfBoundsException_init_$Create$_0 = kotlin_kotlin.$_$.i1;
  var NoSuchElementException_init_$Create$ = kotlin_kotlin.$_$.j1;
  var until = kotlin_kotlin.$_$.ba;
  var joinToString = kotlin_kotlin.$_$.y4;
  var Iterable = kotlin_kotlin.$_$.y2;
  var IllegalStateException_init_$Create$_0 = kotlin_kotlin.$_$.e1;
  var numberToInt = kotlin_kotlin.$_$.b9;
  var copyOf_2 = kotlin_kotlin.$_$.d4;
  var Comparator = kotlin_kotlin.$_$.gc;
  var reversed = kotlin_kotlin.$_$.v6;
  var NotImplementedError = kotlin_kotlin.$_$.mc;
  var toSet = kotlin_kotlin.$_$.q6;
  var contentEquals_1 = kotlin_kotlin.$_$.q3;
  var contentHashCode_1 = kotlin_kotlin.$_$.u3;
  var throwUninitializedPropertyAccessException = kotlin_kotlin.$_$.id;
  var toBits = kotlin_kotlin.$_$.jd;
  var Pair = kotlin_kotlin.$_$.nc;
  var toMap = kotlin_kotlin.$_$.n6;
  var step = kotlin_kotlin.$_$.z9;
  var arrayCopy = kotlin_kotlin.$_$.h3;
  var toRawBits = kotlin_kotlin.$_$.kd;
  var AbstractMutableList = kotlin_kotlin.$_$.u2;
  var copyToArray = kotlin_kotlin.$_$.f4;
  var get_lastIndex = kotlin_kotlin.$_$.b5;
  var joinToString_0 = kotlin_kotlin.$_$.z4;
  var RandomAccess = kotlin_kotlin.$_$.e3;
  var toList_0 = kotlin_kotlin.$_$.l6;
  //endregion
  //region block: pre-declaration
  setMetadataFor(Companion, 'Companion', objectMeta);
  function getAt(x, y) {
    return this.ek(index(this, x, y));
  }
  function asString() {
    var tmp = until(0, this.dk());
    return joinToString(tmp, '\n', VOID, VOID, VOID, VOID, IArray2$asString$lambda(this));
  }
  setMetadataFor(IArray2, 'IArray2', interfaceMeta, VOID, [Iterable]);
  setMetadataFor(IntArray2, 'IntArray2', classMeta, VOID, [IArray2]);
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor(FloatArray2, 'FloatArray2', classMeta, VOID, [IArray2]);
  setMetadataFor(ByteArrayDeque, 'ByteArrayDeque', classMeta);
  setMetadataFor(ShortArrayDeque, 'ShortArrayDeque', classMeta);
  setMetadataFor(FloatArrayDeque, 'FloatArrayDeque', classMeta);
  setMetadataFor(Companion_1, 'Companion', objectMeta);
  setMetadataFor(DoubleArrayList, 'DoubleArrayList', classMeta, VOID, [Collection]);
  setMetadataFor(Companion_2, 'Companion', objectMeta);
  setMetadataFor(FloatArrayList, 'FloatArrayList', classMeta, VOID, [Collection]);
  setMetadataFor(Companion_3, 'Companion', objectMeta);
  setMetadataFor(IntArrayList, 'IntArrayList', classMeta, VOID, [Collection]);
  setMetadataFor(SortOps, 'SortOps', classMeta);
  setMetadataFor(FloatArrayListSortOps, 'FloatArrayListSortOps', objectMeta, SortOps);
  setMetadataFor(DoubleArrayListSortOps, 'DoubleArrayListSortOps', objectMeta, SortOps);
  setMetadataFor(CaseInsensitiveStringMap, 'CaseInsensitiveStringMap', classMeta, VOID, [MutableMap]);
  setMetadataFor(TGenDeque$iterator$1, VOID, classMeta);
  setMetadataFor(TGenDeque, 'TGenDeque', classMeta, VOID, [Collection, MutableIterable]);
  setMetadataFor(IntDeque$iterator$1, VOID, classMeta);
  setMetadataFor(IntDeque, 'IntDeque', classMeta, VOID, [Collection, MutableIterable]);
  function setAddAll(index, elements, offset, size) {
    var tmp$ret$0;
    // Inline function 'kotlin.math.min' call
    var tmp0_min = this.j() - index | 0;
    tmp$ret$0 = Math.min(size, tmp0_min);
    var setCount = tmp$ret$0;
    this.yp(index, elements, offset, setCount);
    this.zp(elements, offset + setCount | 0, size - setCount | 0);
  }
  function setAddAll$default(index, elements, offset, size, $super) {
    offset = offset === VOID ? 0 : offset;
    size = size === VOID ? elements.j() - offset | 0 : size;
    var tmp;
    if ($super === VOID) {
      this.xp(index, elements, offset, size);
      tmp = Unit_getInstance();
    } else {
      setAddAll(index, elements, offset, size);
      tmp = Unit_getInstance();
    }
    return tmp;
  }
  function setAll(index, elements, offset, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.r2(index + n | 0, elements.k(offset + n | 0));
      }
       while (inductionVariable < size);
  }
  function addAll_0(elements, offset, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.b(elements.k(offset + n | 0));
      }
       while (inductionVariable < size);
  }
  function removeToSize(size) {
    this.a3(size, this.j());
  }
  setMetadataFor(MutableListEx, 'MutableListEx', interfaceMeta, VOID, [MutableList]);
  setMetadataFor(FastSmallSet, 'FastSmallSet', classMeta, AbstractMutableSet);
  setMetadataFor(GenericListIterator, 'GenericListIterator', classMeta);
  setMetadataFor(Companion_4, 'Companion', objectMeta);
  setMetadataFor(Companion_5, 'Companion', objectMeta);
  setMetadataFor(IntIntMap, 'IntIntMap', classMeta);
  setMetadataFor(Companion_6, 'Companion', objectMeta);
  setMetadataFor(Entry, 'Entry', classMeta);
  setMetadataFor(Iterator, 'Iterator', classMeta);
  setMetadataFor(_no_name_provided__qut3iv, VOID, classMeta, VOID, [Iterable]);
  setMetadataFor(_no_name_provided__qut3iv_0, VOID, classMeta, VOID, [Iterable]);
  setMetadataFor(IntMap, 'IntMap', classMeta);
  setMetadataFor(Iterator$1, VOID, classMeta);
  setMetadataFor(ListReader, 'ListReader', classMeta);
  setMetadataFor(Companion_7, 'Companion', objectMeta);
  setMetadataFor(Pool, 'Pool', classMeta);
  setMetadataFor(ConcurrentPool, 'ConcurrentPool', classMeta, Pool);
  setMetadataFor(ReturnablePool, 'ReturnablePool', classMeta);
  setMetadataFor(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  setMetadataFor(Companion_8, 'Companion', objectMeta);
  setMetadataFor(TGenPriorityQueue$iterator$1, VOID, classMeta);
  setMetadataFor(TGenPriorityQueue, 'TGenPriorityQueue', classMeta, VOID, [Collection, MutableIterable]);
  setMetadataFor(TGenQueue, 'TGenQueue', classMeta, VOID, [Collection]);
  setMetadataFor(Ref$2, VOID, classMeta);
  setMetadataFor(Ref$3, VOID, classMeta);
  setMetadataFor(ByteRingBuffer, 'ByteRingBuffer', classMeta);
  setMetadataFor(RingBuffer, 'RingBuffer', classMeta, ByteRingBuffer);
  setMetadataFor(ShortRingBuffer, 'ShortRingBuffer', classMeta);
  setMetadataFor(FloatRingBuffer, 'FloatRingBuffer', classMeta);
  setMetadataFor(Companion_9, 'Companion', objectMeta);
  setMetadataFor(TGenStack, 'TGenStack', classMeta, VOID, [Collection]);
  setMetadataFor(Mixin, 'Mixin', classMeta);
  setMetadataFor(Property, 'Property', classMeta);
  setMetadataFor(PropertyThis, 'PropertyThis', classMeta);
  setMetadataFor(FastArrayList, 'FastArrayList', classMeta, AbstractMutableList, [AbstractMutableList, MutableListEx, RandomAccess]);
  setMetadataFor(NonRecursiveLock, 'NonRecursiveLock', classMeta);
  setMetadataFor(Lock, 'Lock', classMeta);
  //endregion
  function Companion() {
    Companion_instance = this;
  }
  var Companion_instance;
  function Companion_getInstance() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function IntArray2(width, height, data) {
    Companion_getInstance();
    this.yj_1 = width;
    this.zj_1 = height;
    this.ak_1 = data;
    Companion_getInstance_4().bk(this.yj_1, this.zj_1, this.ak_1.length);
  }
  protoOf(IntArray2).ck = function () {
    return this.yj_1;
  };
  protoOf(IntArray2).dk = function () {
    return this.zj_1;
  };
  protoOf(IntArray2).ek = function (idx) {
    return this.ak_1[idx];
  };
  protoOf(IntArray2).equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof IntArray2) {
      tmp_1 = this.yj_1 === other.yj_1;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.zj_1 === other.zj_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals(this.ak_1, other.ak_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(IntArray2).fk = function (x, y) {
    return this.ak_1[index(this, x, y)];
  };
  protoOf(IntArray2).gk = function (x, y, value) {
    this.ak_1[index(this, x, y)] = value;
  };
  protoOf(IntArray2).hashCode = function () {
    return (this.yj_1 + this.zj_1 | 0) + contentHashCode(this.ak_1) | 0;
  };
  protoOf(IntArray2).g = function () {
    return intArrayIterator(this.ak_1);
  };
  protoOf(IntArray2).toString = function () {
    return this.hk();
  };
  function Companion_0() {
    Companion_instance_0 = this;
  }
  var Companion_instance_0;
  function Companion_getInstance_0() {
    if (Companion_instance_0 == null)
      new Companion_0();
    return Companion_instance_0;
  }
  function FloatArray2(width, height, data) {
    Companion_getInstance_0();
    this.jk_1 = width;
    this.kk_1 = height;
    this.lk_1 = data;
    Companion_getInstance_4().bk(this.jk_1, this.kk_1, this.lk_1.length);
  }
  protoOf(FloatArray2).ck = function () {
    return this.jk_1;
  };
  protoOf(FloatArray2).dk = function () {
    return this.kk_1;
  };
  protoOf(FloatArray2).ek = function (idx) {
    return this.lk_1[idx];
  };
  protoOf(FloatArray2).equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof FloatArray2) {
      tmp_1 = this.jk_1 === other.jk_1;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.kk_1 === other.kk_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals_0(this.lk_1, other.lk_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(FloatArray2).fk = function (x, y) {
    return this.lk_1[index(this, x, y)];
  };
  protoOf(FloatArray2).mk = function (x, y, value) {
    this.lk_1[index(this, x, y)] = value;
  };
  protoOf(FloatArray2).hashCode = function () {
    return (this.jk_1 + this.kk_1 | 0) + contentHashCode_0(this.lk_1) | 0;
  };
  protoOf(FloatArray2).g = function () {
    return floatArrayIterator(this.lk_1);
  };
  protoOf(FloatArray2).toString = function () {
    return this.hk();
  };
  function ensureWrite($this, count) {
    if (count <= $this.xk_1.tk_1)
      return Unit_getInstance();
    if (!$this.wk_1) {
      var message = "Can't grow ByteArrayDeque. Need to write " + count + ', but only ' + $this.xk_1.tk_1 + ' is available';
      println('ERROR: ' + message);
      // Inline function 'kotlin.error' call
      throw IllegalStateException_init_$Create$(toString(message));
    }
    var minNewSize = $this.xk_1.uk_1 + count | 0;
    var tmp = $this;
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = new RingBuffer(ilog2(minNewSize) + 2 | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.ByteArrayDeque.ensureWrite.<anonymous>' call
    tmp0_also.bl($this.xk_1);
    tmp$ret$0 = tmp0_also;
    tmp.xk_1 = tmp$ret$0;
  }
  function ByteArrayDeque(initialBits, allowGrow) {
    initialBits = initialBits === VOID ? 10 : initialBits;
    allowGrow = allowGrow === VOID ? true : allowGrow;
    this.vk_1 = initialBits;
    this.wk_1 = allowGrow;
    this.xk_1 = new RingBuffer(this.vk_1);
    this.yk_1 = new Int8Array(1024);
    this.zk_1 = new Long(0, 0);
    this.al_1 = new Long(0, 0);
  }
  protoOf(ByteArrayDeque).cl = function () {
    return this.xk_1.uk_1;
  };
  protoOf(ByteArrayDeque).dl = function (buffer, offset, size) {
    ensureWrite(this, size);
    var out = this.xk_1.dl(buffer, offset, size);
    if (out > 0) {
      var tmp0_this = this;
      var tmp = tmp0_this;
      var tmp$ret$0;
      // Inline function 'kotlin.Long.plus' call
      var tmp0_plus = tmp0_this.zk_1;
      tmp$ret$0 = tmp0_plus.m5(toLong(out));
      tmp.zk_1 = tmp$ret$0;
    }
    return out;
  };
  protoOf(ByteArrayDeque).el = function (buffer, offset, size, $super) {
    offset = offset === VOID ? 0 : offset;
    size = size === VOID ? buffer.length - offset | 0 : size;
    return $super === VOID ? this.dl(buffer, offset, size) : $super.dl.call(this, buffer, offset, size);
  };
  protoOf(ByteArrayDeque).fl = function (count) {
    return this.xk_1.fl(count);
  };
  protoOf(ByteArrayDeque).gl = function (buffer, offset, size) {
    return this.xk_1.gl(buffer, offset, size);
  };
  protoOf(ByteArrayDeque).v2 = function () {
    this.xk_1.v2();
  };
  protoOf(ByteArrayDeque).hashCode = function () {
    return this.xk_1.hl();
  };
  protoOf(ByteArrayDeque).equals = function (other) {
    var tmp;
    if (other instanceof ByteArrayDeque) {
      tmp = this.xk_1.equals(other.xk_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function ensureWrite_0($this, count) {
    if (count > $this.sl_1.ol_1) {
      var minNewSize = $this.sl_1.pl_1 + count | 0;
      var newBits = ilog2(minNewSize) + 2 | 0;
      var newRing = new ShortRingBuffer(newBits);
      while ($this.sl_1.pl_1 > 0) {
        var read = $this.sl_1.wl($this.tl_1, 0, $this.tl_1.length);
        newRing.xl($this.tl_1, 0, read);
      }
      $this.sl_1 = newRing;
    }
    return $this;
  }
  function ShortArrayDeque(initialBits) {
    initialBits = initialBits === VOID ? 10 : initialBits;
    this.rl_1 = initialBits;
    this.sl_1 = new ShortRingBuffer(this.rl_1);
    this.tl_1 = new Int16Array(1024);
    this.ul_1 = new Long(0, 0);
    this.vl_1 = new Long(0, 0);
  }
  protoOf(ShortArrayDeque).cl = function () {
    return this.sl_1.pl_1;
  };
  protoOf(ShortArrayDeque).xl = function (buffer, offset, size) {
    var out = ensureWrite_0(this, size).sl_1.xl(buffer, offset, size);
    if (out > 0) {
      var tmp0_this = this;
      var tmp = tmp0_this;
      var tmp$ret$0;
      // Inline function 'kotlin.Long.plus' call
      var tmp0_plus = tmp0_this.ul_1;
      tmp$ret$0 = tmp0_plus.m5(toLong(out));
      tmp.ul_1 = tmp$ret$0;
    }
    return out;
  };
  protoOf(ShortArrayDeque).wl = function (buffer, offset, size) {
    var out = this.sl_1.wl(buffer, offset, size);
    if (out > 0) {
      var tmp0_this = this;
      var tmp = tmp0_this;
      var tmp$ret$0;
      // Inline function 'kotlin.Long.plus' call
      var tmp0_plus = tmp0_this.vl_1;
      tmp$ret$0 = tmp0_plus.m5(toLong(out));
      tmp.vl_1 = tmp$ret$0;
    }
    return out;
  };
  protoOf(ShortArrayDeque).v2 = function () {
    this.sl_1.v2();
  };
  protoOf(ShortArrayDeque).yl = function (value) {
    this.tl_1[0] = value;
    this.xl(this.tl_1, 0, 1);
  };
  protoOf(ShortArrayDeque).hashCode = function () {
    return this.sl_1.hl();
  };
  protoOf(ShortArrayDeque).equals = function (other) {
    var tmp;
    if (other instanceof ShortArrayDeque) {
      tmp = this.sl_1.equals(other.sl_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function ensureWrite_1($this, count) {
    if (count > $this.im_1.fm_1) {
      var minNewSize = $this.im_1.gm_1 + count | 0;
      var newBits = ilog2(minNewSize) + 2 | 0;
      var newRing = new FloatRingBuffer(newBits);
      while ($this.im_1.gm_1 > 0) {
        var read = $this.im_1.mm($this.jm_1, 0, $this.jm_1.length);
        newRing.nm($this.jm_1, 0, read);
      }
      $this.im_1 = newRing;
    }
    return $this;
  }
  function FloatArrayDeque(initialBits) {
    initialBits = initialBits === VOID ? 10 : initialBits;
    this.hm_1 = initialBits;
    this.im_1 = new FloatRingBuffer(this.hm_1);
    this.jm_1 = new Float32Array(1024);
    this.km_1 = new Long(0, 0);
    this.lm_1 = new Long(0, 0);
  }
  protoOf(FloatArrayDeque).cl = function () {
    return this.im_1.gm_1;
  };
  protoOf(FloatArrayDeque).nm = function (buffer, offset, size) {
    var out = ensureWrite_1(this, size).im_1.nm(buffer, offset, size);
    if (out > 0) {
      var tmp0_this = this;
      var tmp = tmp0_this;
      var tmp$ret$0;
      // Inline function 'kotlin.Long.plus' call
      var tmp0_plus = tmp0_this.km_1;
      tmp$ret$0 = tmp0_plus.m5(toLong(out));
      tmp.km_1 = tmp$ret$0;
    }
    return out;
  };
  protoOf(FloatArrayDeque).mm = function (buffer, offset, size) {
    var out = this.im_1.mm(buffer, offset, size);
    if (out > 0) {
      var tmp0_this = this;
      var tmp = tmp0_this;
      var tmp$ret$0;
      // Inline function 'kotlin.Long.plus' call
      var tmp0_plus = tmp0_this.lm_1;
      tmp$ret$0 = tmp0_plus.m5(toLong(out));
      tmp.lm_1 = tmp$ret$0;
    }
    return out;
  };
  protoOf(FloatArrayDeque).om = function (buffer, offset, size, $super) {
    offset = offset === VOID ? 0 : offset;
    size = size === VOID ? buffer.length - offset | 0 : size;
    return $super === VOID ? this.mm(buffer, offset, size) : $super.mm.call(this, buffer, offset, size);
  };
  protoOf(FloatArrayDeque).hashCode = function () {
    return this.im_1.hl();
  };
  protoOf(FloatArrayDeque).equals = function (other) {
    var tmp;
    if (other instanceof FloatArrayDeque) {
      tmp = this.im_1.equals(other.im_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function swap(_this__u8e3s4, lIndex, rIndex) {
    var temp = _this__u8e3s4[lIndex];
    _this__u8e3s4[lIndex] = _this__u8e3s4[rIndex];
    _this__u8e3s4[rIndex] = temp;
  }
  function rotateRight(_this__u8e3s4, offset) {
    offset = offset === VOID ? 1 : offset;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure._rotateRight' call
      var tmp1__rotateRight = _this__u8e3s4.length;
      var offset_0 = umod(offset, tmp1__rotateRight);
      if (offset_0 === 0) {
        tmp$ret$0 = Unit_getInstance();
        break $l$block;
      }
      // Inline function 'kotlin.check' call
      var tmp0_check = 1 <= offset_0 ? offset_0 < tmp1__rotateRight : false;
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!tmp0_check) {
        var tmp$ret$1;
        // Inline function 'kotlin.check.<anonymous>' call
        tmp$ret$1 = 'Check failed.';
        var message = tmp$ret$1;
        throw IllegalStateException_init_$Create$(toString(message));
      }
      // Inline function 'korlibs.datastructure.rotateRight.<anonymous>' call
      reverse(_this__u8e3s4, 0, tmp1__rotateRight);
      // Inline function 'korlibs.datastructure.rotateRight.<anonymous>' call
      reverse(_this__u8e3s4, 0, offset_0);
      // Inline function 'korlibs.datastructure.rotateRight.<anonymous>' call
      reverse(_this__u8e3s4, offset_0, tmp1__rotateRight);
    }
    return tmp$ret$0;
  }
  function Companion_1() {
    Companion_instance_1 = this;
  }
  var Companion_instance_1;
  function Companion_getInstance_1() {
    if (Companion_instance_1 == null)
      new Companion_1();
    return Companion_instance_1;
  }
  function ensure($this, count) {
    if (($this.qm_1 + count | 0) > $this.pm_1.length) {
      var tmp = $this;
      var tmp_0 = $this.pm_1;
      var tmp$ret$0;
      // Inline function 'kotlin.math.max' call
      var tmp0_max = $this.qm_1 + count | 0;
      var tmp1_max = imul($this.pm_1.length, 3);
      tmp$ret$0 = Math.max(tmp0_max, tmp1_max);
      var tmp_1 = copyOf(tmp_0, tmp$ret$0);
      tmp.pm_1 = isDoubleArray(tmp_1) ? tmp_1 : THROW_CCE();
    }
  }
  function DoubleArrayList(capacity) {
    Companion_getInstance_1();
    capacity = capacity === VOID ? 7 : capacity;
    var tmp = this;
    var tmp_0 = new Float64Array(capacity);
    tmp.pm_1 = isDoubleArray(tmp_0) ? tmp_0 : THROW_CCE();
    this.qm_1 = 0;
  }
  protoOf(DoubleArrayList).j = function () {
    return this.qm_1;
  };
  protoOf(DoubleArrayList).v2 = function () {
    this.qm_1 = 0;
  };
  protoOf(DoubleArrayList).rm = function (v0) {
    ensure(this, 1);
    var tmp = this.pm_1;
    var tmp0_this = this;
    var tmp1 = tmp0_this.qm_1;
    tmp0_this.qm_1 = tmp1 + 1 | 0;
    tmp[tmp1] = v0;
  };
  protoOf(DoubleArrayList).sm = function (v0, v1) {
    ensure(this, 2);
    var tmp = this.pm_1;
    var tmp0_this = this;
    var tmp1 = tmp0_this.qm_1;
    tmp0_this.qm_1 = tmp1 + 1 | 0;
    tmp[tmp1] = v0;
    var tmp_0 = this.pm_1;
    var tmp2_this = this;
    var tmp3 = tmp2_this.qm_1;
    tmp2_this.qm_1 = tmp3 + 1 | 0;
    tmp_0[tmp3] = v1;
  };
  protoOf(DoubleArrayList).tm = function (value) {
    return this.rm(value);
  };
  protoOf(DoubleArrayList).k = function (index) {
    return this.pm_1[index];
  };
  protoOf(DoubleArrayList).ek = function (index) {
    return this.pm_1[index];
  };
  protoOf(DoubleArrayList).um = function (index, value) {
    if (index >= this.qm_1) {
      ensure(this, index + 1 | 0);
      this.qm_1 = index + 1 | 0;
    }
    this.pm_1[index] = value;
  };
  protoOf(DoubleArrayList).g = function () {
    return this.z2(0);
  };
  protoOf(DoubleArrayList).vm = function (element) {
    var inductionVariable = 0;
    var last = this.qm_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.pm_1[n] === element)
          return true;
      }
       while (inductionVariable < last);
    return false;
  };
  protoOf(DoubleArrayList).wm = function (elements) {
    var tmp0_iterator = elements.g();
    while (tmp0_iterator.h()) {
      var e = tmp0_iterator.i();
      if (!this.vm(e))
        return false;
    }
    return true;
  };
  protoOf(DoubleArrayList).h1 = function (elements) {
    return this.wm(elements);
  };
  protoOf(DoubleArrayList).l = function () {
    return this.j() === 0;
  };
  protoOf(DoubleArrayList).xm = function (indexA, indexB) {
    var l = this.ek(indexA);
    var r = this.ek(indexB);
    this.um(indexA, r);
    this.um(indexB, l);
  };
  protoOf(DoubleArrayList).u2 = function (index) {
    return this.ym(index, 1);
  };
  protoOf(DoubleArrayList).ym = function (index, count) {
    if ((index < 0 ? true : index >= this.qm_1) ? true : (index + count | 0) > this.qm_1)
      throw IndexOutOfBoundsException_init_$Create$();
    var out = this.pm_1[index];
    if (count > 0) {
      if (index < (this.qm_1 - count | 0)) {
        arraycopy(this.pm_1, index + count | 0, this.pm_1, index, (this.qm_1 - index | 0) - count | 0);
      }
      var tmp0_this = this;
      tmp0_this.qm_1 = tmp0_this.qm_1 - count | 0;
    }
    return out;
  };
  protoOf(DoubleArrayList).z2 = function (index) {
    return take(this.pm_1, this.qm_1).z2(index);
  };
  protoOf(DoubleArrayList).hashCode = function () {
    return contentHashCode_2(this.pm_1, 0, this.j());
  };
  protoOf(DoubleArrayList).equals = function (other) {
    if (other instanceof DoubleArrayList)
      return this.j() === other.j() ? contentEquals_2(this.pm_1, other.pm_1, 0, this.j()) : false;
    if (!(other == null) ? isInterface(other, List) : false)
      return equals(other, this);
    return false;
  };
  protoOf(DoubleArrayList).toString = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = StringBuilder_init_$Create$(2 + imul(5, this.j()) | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.DoubleArrayList.toString.<anonymous>' call
    tmp0_also.f7(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.j();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          tmp0_also.ve(', ');
        }
        tmp0_also.ue(this.ek(n));
      }
       while (inductionVariable < last);
    tmp0_also.f7(_Char___init__impl__6a9atx(93));
    tmp$ret$0 = tmp0_also;
    return tmp$ret$0.toString();
  };
  function Companion_2() {
    Companion_instance_2 = this;
  }
  var Companion_instance_2;
  function Companion_getInstance_2() {
    if (Companion_instance_2 == null)
      new Companion_2();
    return Companion_instance_2;
  }
  function FloatArrayList_init_$Init$(other, $this) {
    FloatArrayList.call($this);
    $this.bn(other);
    return $this;
  }
  function FloatArrayList_init_$Create$(other) {
    return FloatArrayList_init_$Init$(other, objectCreate(protoOf(FloatArrayList)));
  }
  function FloatArrayList_init_$Init$_0(other, $this) {
    FloatArrayList.call($this);
    $this.cn(other);
    return $this;
  }
  function FloatArrayList_init_$Create$_0(other) {
    return FloatArrayList_init_$Init$_0(other, objectCreate(protoOf(FloatArrayList)));
  }
  function ensure_0($this, count) {
    if (($this.an_1 + count | 0) > $this.zm_1.length) {
      var tmp = $this;
      var tmp_0 = $this.zm_1;
      var tmp$ret$0;
      // Inline function 'kotlin.math.max' call
      var tmp0_max = $this.an_1 + count | 0;
      var tmp1_max = imul($this.zm_1.length, 3);
      tmp$ret$0 = Math.max(tmp0_max, tmp1_max);
      var tmp_1 = copyOf_0(tmp_0, tmp$ret$0);
      tmp.zm_1 = isFloatArray(tmp_1) ? tmp_1 : THROW_CCE();
    }
  }
  function FloatArrayList(capacity) {
    Companion_getInstance_2();
    capacity = capacity === VOID ? 7 : capacity;
    var tmp = this;
    var tmp_0 = new Float32Array(capacity);
    tmp.zm_1 = isFloatArray(tmp_0) ? tmp_0 : THROW_CCE();
    this.an_1 = 0;
  }
  protoOf(FloatArrayList).dn = function () {
    return FloatArrayList_init_$Create$(this);
  };
  protoOf(FloatArrayList).en = function (value) {
    ensure_0(this, value);
    this.an_1 = value;
  };
  protoOf(FloatArrayList).j = function () {
    return this.an_1;
  };
  protoOf(FloatArrayList).v2 = function () {
    this.an_1 = 0;
  };
  protoOf(FloatArrayList).fn = function (value) {
    ensure_0(this, 1);
    var tmp = this.zm_1;
    var tmp0_this = this;
    var tmp1 = tmp0_this.an_1;
    tmp0_this.an_1 = tmp1 + 1 | 0;
    tmp[tmp1] = value;
  };
  protoOf(FloatArrayList).gn = function (v0, v1) {
    ensure_0(this, 2);
    var tmp = this.zm_1;
    var tmp0_this = this;
    var tmp1 = tmp0_this.an_1;
    tmp0_this.an_1 = tmp1 + 1 | 0;
    tmp[tmp1] = v0;
    var tmp_0 = this.zm_1;
    var tmp2_this = this;
    var tmp3 = tmp2_this.an_1;
    tmp2_this.an_1 = tmp3 + 1 | 0;
    tmp_0[tmp3] = v1;
  };
  protoOf(FloatArrayList).hn = function (v0, v1, v2, v3) {
    ensure_0(this, 4);
    var tmp = this.zm_1;
    var tmp0_this = this;
    var tmp1 = tmp0_this.an_1;
    tmp0_this.an_1 = tmp1 + 1 | 0;
    tmp[tmp1] = v0;
    var tmp_0 = this.zm_1;
    var tmp2_this = this;
    var tmp3 = tmp2_this.an_1;
    tmp2_this.an_1 = tmp3 + 1 | 0;
    tmp_0[tmp3] = v1;
    var tmp_1 = this.zm_1;
    var tmp4_this = this;
    var tmp5 = tmp4_this.an_1;
    tmp4_this.an_1 = tmp5 + 1 | 0;
    tmp_1[tmp5] = v2;
    var tmp_2 = this.zm_1;
    var tmp6_this = this;
    var tmp7 = tmp6_this.an_1;
    tmp6_this.an_1 = tmp7 + 1 | 0;
    tmp_2[tmp7] = v3;
  };
  protoOf(FloatArrayList).in = function (v0, v1, v2, v3, v4, v5) {
    ensure_0(this, 6);
    var tmp = this.zm_1;
    var tmp0_this = this;
    var tmp1 = tmp0_this.an_1;
    tmp0_this.an_1 = tmp1 + 1 | 0;
    tmp[tmp1] = v0;
    var tmp_0 = this.zm_1;
    var tmp2_this = this;
    var tmp3 = tmp2_this.an_1;
    tmp2_this.an_1 = tmp3 + 1 | 0;
    tmp_0[tmp3] = v1;
    var tmp_1 = this.zm_1;
    var tmp4_this = this;
    var tmp5 = tmp4_this.an_1;
    tmp4_this.an_1 = tmp5 + 1 | 0;
    tmp_1[tmp5] = v2;
    var tmp_2 = this.zm_1;
    var tmp6_this = this;
    var tmp7 = tmp6_this.an_1;
    tmp6_this.an_1 = tmp7 + 1 | 0;
    tmp_2[tmp7] = v3;
    var tmp_3 = this.zm_1;
    var tmp8_this = this;
    var tmp9 = tmp8_this.an_1;
    tmp8_this.an_1 = tmp9 + 1 | 0;
    tmp_3[tmp9] = v4;
    var tmp_4 = this.zm_1;
    var tmp10_this = this;
    var tmp11 = tmp10_this.an_1;
    tmp10_this.an_1 = tmp11 + 1 | 0;
    tmp_4[tmp11] = v5;
  };
  protoOf(FloatArrayList).jn = function (value) {
    return this.bn(value);
  };
  protoOf(FloatArrayList).kn = function (values, offset, length) {
    ensure_0(this, length);
    arraycopy_0(isFloatArray(values) ? values : THROW_CCE(), offset, this.zm_1, this.j(), length);
    var tmp0_this = this;
    tmp0_this.en(tmp0_this.j() + length | 0);
  };
  protoOf(FloatArrayList).cn = function (values, offset, length, $super) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? values.length : length;
    var tmp;
    if ($super === VOID) {
      this.kn(values, offset, length);
      tmp = Unit_getInstance();
    } else {
      tmp = $super.kn.call(this, values, offset, length);
    }
    return tmp;
  };
  protoOf(FloatArrayList).bn = function (values) {
    return this.kn(values.zm_1, 0, values.j());
  };
  protoOf(FloatArrayList).k = function (index) {
    return this.zm_1[index];
  };
  protoOf(FloatArrayList).ek = function (index) {
    return this.zm_1[index];
  };
  protoOf(FloatArrayList).ln = function (index, value) {
    if (index >= this.an_1) {
      ensure_0(this, index + 1 | 0);
      this.an_1 = index + 1 | 0;
    }
    this.zm_1[index] = value;
  };
  protoOf(FloatArrayList).g = function () {
    return this.z2(0);
  };
  protoOf(FloatArrayList).mn = function (element) {
    var inductionVariable = 0;
    var last = this.an_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.zm_1[n] === element)
          return true;
      }
       while (inductionVariable < last);
    return false;
  };
  protoOf(FloatArrayList).nn = function (elements) {
    var tmp0_iterator = elements.g();
    while (tmp0_iterator.h()) {
      var e = tmp0_iterator.i();
      if (!this.mn(e))
        return false;
    }
    return true;
  };
  protoOf(FloatArrayList).h1 = function (elements) {
    return this.nn(elements);
  };
  protoOf(FloatArrayList).l = function () {
    return this.j() === 0;
  };
  protoOf(FloatArrayList).ym = function (index, count) {
    if ((index < 0 ? true : index >= this.an_1) ? true : (index + count | 0) > this.an_1)
      throw IndexOutOfBoundsException_init_$Create$();
    var out = this.zm_1[index];
    if (count > 0) {
      if (index < (this.an_1 - count | 0)) {
        arraycopy_0(this.zm_1, index + count | 0, this.zm_1, index, (this.an_1 - index | 0) - count | 0);
      }
      var tmp0_this = this;
      tmp0_this.an_1 = tmp0_this.an_1 - count | 0;
    }
    return out;
  };
  protoOf(FloatArrayList).on = function () {
    return copyOf_0(this.zm_1, this.an_1);
  };
  protoOf(FloatArrayList).z2 = function (index) {
    return take_0(this.zm_1, this.an_1).z2(index);
  };
  protoOf(FloatArrayList).hashCode = function () {
    return contentHashCode_3(this.zm_1, 0, this.j());
  };
  protoOf(FloatArrayList).equals = function (other) {
    if (other instanceof FloatArrayList)
      return this.j() === other.j() ? contentEquals_3(this.zm_1, other.zm_1, 0, this.j()) : false;
    if (!(other == null) ? isInterface(other, List) : false)
      return equals(other, this);
    return false;
  };
  protoOf(FloatArrayList).toString = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = StringBuilder_init_$Create$(2 + imul(5, this.j()) | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.FloatArrayList.toString.<anonymous>' call
    tmp0_also.f7(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.j();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          tmp0_also.ve(', ');
        }
        tmp0_also.ue(this.ek(n));
      }
       while (inductionVariable < last);
    tmp0_also.f7(_Char___init__impl__6a9atx(93));
    tmp$ret$0 = tmp0_also;
    return tmp$ret$0.toString();
  };
  function Companion_3() {
    Companion_instance_3 = this;
  }
  var Companion_instance_3;
  function Companion_getInstance_3() {
    if (Companion_instance_3 == null)
      new Companion_3();
    return Companion_instance_3;
  }
  function IntArrayList_init_$Init$(other, $this) {
    IntArrayList.call($this);
    $this.rn(other);
    return $this;
  }
  function IntArrayList_init_$Create$(other) {
    return IntArrayList_init_$Init$(other, objectCreate(protoOf(IntArrayList)));
  }
  function IntArrayList_init_$Init$_0(other, $this) {
    IntArrayList.call($this);
    $this.sn(other);
    return $this;
  }
  function IntArrayList_init_$Create$_0(other) {
    return IntArrayList_init_$Init$_0(other, objectCreate(protoOf(IntArrayList)));
  }
  function IntArrayList(capacity) {
    Companion_getInstance_3();
    capacity = capacity === VOID ? 7 : capacity;
    var tmp = this;
    var tmp_0 = new Int32Array(capacity);
    tmp.pn_1 = isIntArray(tmp_0) ? tmp_0 : THROW_CCE();
    this.qn_1 = 0;
  }
  protoOf(IntArrayList).en = function (value) {
    this.tn(value);
    this.qn_1 = value;
  };
  protoOf(IntArrayList).j = function () {
    return this.qn_1;
  };
  protoOf(IntArrayList).tn = function (count) {
    if ((this.qn_1 + count | 0) > this.pn_1.length) {
      var tmp = this;
      var tmp_0 = this.pn_1;
      var tmp$ret$0;
      // Inline function 'kotlin.math.max' call
      var tmp0_max = this.qn_1 + count | 0;
      var tmp1_max = imul(this.pn_1.length, 3);
      tmp$ret$0 = Math.max(tmp0_max, tmp1_max);
      var tmp_1 = copyOf_1(tmp_0, tmp$ret$0);
      tmp.pn_1 = isIntArray(tmp_1) ? tmp_1 : THROW_CCE();
    }
  };
  protoOf(IntArrayList).v2 = function () {
    this.qn_1 = 0;
  };
  protoOf(IntArrayList).un = function (v0) {
    this.tn(1);
    var tmp = this.pn_1;
    var tmp0_this = this;
    var tmp1 = tmp0_this.qn_1;
    tmp0_this.qn_1 = tmp1 + 1 | 0;
    tmp[tmp1] = v0;
  };
  protoOf(IntArrayList).vn = function (value) {
    return this.un(value);
  };
  protoOf(IntArrayList).wn = function (value) {
    return this.rn(value);
  };
  protoOf(IntArrayList).xn = function (values, offset, length) {
    this.tn(length);
    arraycopy_1(isIntArray(values) ? values : THROW_CCE(), offset, this.pn_1, this.j(), length);
    var tmp0_this = this;
    tmp0_this.en(tmp0_this.j() + length | 0);
  };
  protoOf(IntArrayList).sn = function (values, offset, length, $super) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? values.length : length;
    var tmp;
    if ($super === VOID) {
      this.xn(values, offset, length);
      tmp = Unit_getInstance();
    } else {
      tmp = $super.xn.call(this, values, offset, length);
    }
    return tmp;
  };
  protoOf(IntArrayList).rn = function (values) {
    return this.xn(values.pn_1, 0, values.j());
  };
  protoOf(IntArrayList).k = function (index) {
    return this.pn_1[index];
  };
  protoOf(IntArrayList).ek = function (index) {
    return this.pn_1[index];
  };
  protoOf(IntArrayList).yn = function (index, value) {
    if (index >= this.qn_1) {
      this.tn(index + 1 | 0);
      this.qn_1 = index + 1 | 0;
    }
    this.pn_1[index] = value;
  };
  protoOf(IntArrayList).g = function () {
    return this.z2(0);
  };
  protoOf(IntArrayList).l6 = function (element) {
    var inductionVariable = 0;
    var last = this.qn_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.pn_1[n] === element)
          return true;
      }
       while (inductionVariable < last);
    return false;
  };
  protoOf(IntArrayList).zn = function (elements) {
    var tmp0_iterator = elements.g();
    while (tmp0_iterator.h()) {
      var e = tmp0_iterator.i();
      if (!this.l6(e))
        return false;
    }
    return true;
  };
  protoOf(IntArrayList).h1 = function (elements) {
    return this.zn(elements);
  };
  protoOf(IntArrayList).l = function () {
    return this.j() === 0;
  };
  protoOf(IntArrayList).ao = function () {
    return !(this.j() === 0);
  };
  protoOf(IntArrayList).bo = function () {
    var tmp;
    if (this.l()) {
      throw IndexOutOfBoundsException_init_$Create$();
    } else {
      tmp = this.pn_1[0];
    }
    return tmp;
  };
  protoOf(IntArrayList).co = function () {
    var tmp;
    if (this.l()) {
      throw IndexOutOfBoundsException_init_$Create$();
    } else {
      tmp = this.pn_1[this.qn_1 - 1 | 0];
    }
    return tmp;
  };
  protoOf(IntArrayList).do = function (index, value) {
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntArrayList.insertAt.<anonymous>' call
    this.tn(1);
    if (this.ao()) {
      arraycopy_1(this.pn_1, index, this.pn_1, index + 1 | 0, this.qn_1 - index | 0);
    }
    this.pn_1[index] = value;
    var tmp0_this = this;
    var tmp1 = tmp0_this.qn_1;
    tmp0_this.qn_1 = tmp1 + 1 | 0;
    tmp$ret$0 = this;
    return tmp$ret$0;
  };
  protoOf(IntArrayList).xm = function (indexA, indexB) {
    var l = this.ek(indexA);
    var r = this.ek(indexB);
    this.yn(indexA, r);
    this.yn(indexB, l);
  };
  protoOf(IntArrayList).u2 = function (index) {
    return this.ym(index, 1);
  };
  protoOf(IntArrayList).ym = function (index, count) {
    if ((index < 0 ? true : index >= this.qn_1) ? true : (index + count | 0) > this.qn_1)
      throw IndexOutOfBoundsException_init_$Create$();
    var out = this.pn_1[index];
    if (count > 0) {
      if (index < (this.qn_1 - count | 0)) {
        arraycopy_1(this.pn_1, index + count | 0, this.pn_1, index, (this.qn_1 - index | 0) - count | 0);
      }
      var tmp0_this = this;
      tmp0_this.qn_1 = tmp0_this.qn_1 - count | 0;
    }
    return out;
  };
  protoOf(IntArrayList).eo = function () {
    return copyOf_1(this.pn_1, this.qn_1);
  };
  protoOf(IntArrayList).z2 = function (index) {
    return take_1(this.pn_1, this.qn_1).z2(index);
  };
  protoOf(IntArrayList).hashCode = function () {
    return contentHashCode_4(this.pn_1, 0, this.j());
  };
  protoOf(IntArrayList).equals = function (other) {
    if (other instanceof IntArrayList)
      return this.j() === other.j() ? contentEquals_4(this.pn_1, other.pn_1, 0, this.j()) : false;
    if (!(other == null) ? isInterface(other, List) : false)
      return equals(other, this);
    return false;
  };
  protoOf(IntArrayList).toString = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = StringBuilder_init_$Create$(2 + imul(5, this.j()) | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntArrayList.toString.<anonymous>' call
    tmp0_also.f7(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.j();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          tmp0_also.ve(', ');
        }
        tmp0_also.ue(this.ek(n));
      }
       while (inductionVariable < last);
    tmp0_also.f7(_Char___init__impl__6a9atx(93));
    tmp$ret$0 = tmp0_also;
    return tmp$ret$0.toString();
  };
  function intArrayListOf(values) {
    return IntArrayList_init_$Create$_0(values.slice());
  }
  function toIntArrayList(_this__u8e3s4) {
    return IntArrayList_init_$Create$_0(_this__u8e3s4.slice());
  }
  function floatArrayListOf(values) {
    return FloatArrayList_init_$Create$_0(values.slice());
  }
  function sort(_this__u8e3s4, start, end, reversed) {
    start = start === VOID ? 0 : start;
    end = end === VOID ? _this__u8e3s4.j() : end;
    reversed = reversed === VOID ? false : reversed;
    return genericSort_0(_this__u8e3s4, start, end - 1 | 0, FloatArrayListSortOps_getInstance(), reversed);
  }
  function reverse_0(_this__u8e3s4, start, end) {
    start = start === VOID ? 0 : start;
    end = end === VOID ? _this__u8e3s4.j() : end;
    return DoubleArrayListSortOps_getInstance().fo(_this__u8e3s4, start, end - 1 | 0);
  }
  function FloatArrayListSortOps() {
    FloatArrayListSortOps_instance = this;
    SortOps.call(this);
  }
  protoOf(FloatArrayListSortOps).go = function (subject, l, r) {
    return compareTo(subject.ek(l), subject.ek(r));
  };
  protoOf(FloatArrayListSortOps).ho = function (subject, l, r) {
    return this.go(subject instanceof FloatArrayList ? subject : THROW_CCE(), l, r);
  };
  protoOf(FloatArrayListSortOps).io = function (subject, indexL, indexR) {
    var l = subject.ek(indexL);
    var r = subject.ek(indexR);
    subject.ln(indexR, l);
    subject.ln(indexL, r);
  };
  protoOf(FloatArrayListSortOps).jo = function (subject, indexL, indexR) {
    return this.io(subject instanceof FloatArrayList ? subject : THROW_CCE(), indexL, indexR);
  };
  var FloatArrayListSortOps_instance;
  function FloatArrayListSortOps_getInstance() {
    if (FloatArrayListSortOps_instance == null)
      new FloatArrayListSortOps();
    return FloatArrayListSortOps_instance;
  }
  function DoubleArrayListSortOps() {
    DoubleArrayListSortOps_instance = this;
    SortOps.call(this);
  }
  protoOf(DoubleArrayListSortOps).lo = function (subject, l, r) {
    return compareTo(subject.ek(l), subject.ek(r));
  };
  protoOf(DoubleArrayListSortOps).ho = function (subject, l, r) {
    return this.lo(subject instanceof DoubleArrayList ? subject : THROW_CCE(), l, r);
  };
  protoOf(DoubleArrayListSortOps).mo = function (subject, indexL, indexR) {
    var l = subject.ek(indexL);
    var r = subject.ek(indexR);
    subject.um(indexR, l);
    subject.um(indexL, r);
  };
  protoOf(DoubleArrayListSortOps).jo = function (subject, indexL, indexR) {
    return this.mo(subject instanceof DoubleArrayList ? subject : THROW_CCE(), indexL, indexR);
  };
  var DoubleArrayListSortOps_instance;
  function DoubleArrayListSortOps_getInstance() {
    if (DoubleArrayListSortOps_instance == null)
      new DoubleArrayListSortOps();
    return DoubleArrayListSortOps_instance;
  }
  function CaseInsensitiveStringMap_init_$Init$($this) {
    CaseInsensitiveStringMap.call($this, LinkedHashMap_init_$Create$(), LinkedHashMap_init_$Create$(), LinkedHashMap_init_$Create$());
    return $this;
  }
  function CaseInsensitiveStringMap_init_$Create$() {
    return CaseInsensitiveStringMap_init_$Init$(objectCreate(protoOf(CaseInsensitiveStringMap)));
  }
  function CaseInsensitiveStringMap(mapOrig, lcToOrig, mapLC) {
    this.no_1 = mapOrig;
    this.oo_1 = lcToOrig;
    this.po_1 = mapLC;
  }
  protoOf(CaseInsensitiveStringMap).o = function () {
    return this.no_1.o();
  };
  protoOf(CaseInsensitiveStringMap).a2 = function () {
    return this.no_1.a2();
  };
  protoOf(CaseInsensitiveStringMap).j = function () {
    return this.no_1.j();
  };
  protoOf(CaseInsensitiveStringMap).eb = function () {
    return this.no_1.eb();
  };
  protoOf(CaseInsensitiveStringMap).l = function () {
    return this.no_1.l();
  };
  protoOf(CaseInsensitiveStringMap).qo = function (key) {
    var tmp$ret$1;
    // Inline function 'kotlin.text.toLowerCase' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = key;
    tmp$ret$1 = tmp$ret$0.toLowerCase();
    return this.po_1.v1(tmp$ret$1);
  };
  protoOf(CaseInsensitiveStringMap).v1 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.qo((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(CaseInsensitiveStringMap).ro = function (key) {
    var tmp$ret$1;
    // Inline function 'kotlin.text.toLowerCase' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = key;
    tmp$ret$1 = tmp$ret$0.toLowerCase();
    return this.po_1.z1(tmp$ret$1);
  };
  protoOf(CaseInsensitiveStringMap).z1 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.ro((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(CaseInsensitiveStringMap).so = function (key, value) {
    this.to(key);
    // Inline function 'kotlin.collections.set' call
    var tmp0_set = this.no_1;
    tmp0_set.x3(key, value);
    // Inline function 'kotlin.collections.set' call
    var tmp1_set = this.oo_1;
    var tmp$ret$1;
    // Inline function 'kotlin.text.toLowerCase' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = key;
    tmp$ret$1 = tmp$ret$0.toLowerCase();
    var tmp2_set = tmp$ret$1;
    tmp1_set.x3(tmp2_set, key);
    var tmp$ret$3;
    // Inline function 'kotlin.text.toLowerCase' call
    var tmp$ret$2;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$2 = key;
    tmp$ret$3 = tmp$ret$2.toLowerCase();
    return this.po_1.x3(tmp$ret$3, value);
  };
  protoOf(CaseInsensitiveStringMap).x3 = function (key, value) {
    var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
    return this.so(tmp, (value == null ? true : isObject(value)) ? value : THROW_CCE());
  };
  protoOf(CaseInsensitiveStringMap).uo = function (from) {
    var tmp$ret$0;
    // Inline function 'kotlin.collections.iterator' call
    tmp$ret$0 = from.o().g();
    var tmp0_iterator = tmp$ret$0;
    while (tmp0_iterator.h()) {
      var v = tmp0_iterator.i();
      this.so(v.p(), v.q());
    }
  };
  protoOf(CaseInsensitiveStringMap).to = function (key) {
    var tmp$ret$1;
    // Inline function 'kotlin.text.toLowerCase' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = key;
    tmp$ret$1 = tmp$ret$0.toLowerCase();
    var lkey = tmp$ret$1;
    var okey = this.oo_1.z1(lkey);
    var tmp$ret$2;
    // Inline function 'kotlin.collections.remove' call
    var tmp0_remove = this.no_1;
    tmp$ret$2 = (isInterface(tmp0_remove, MutableMap) ? tmp0_remove : THROW_CCE()).fb(okey);
    var res = this.po_1.fb(lkey);
    this.oo_1.fb(lkey);
    return res;
  };
  protoOf(CaseInsensitiveStringMap).fb = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.to((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(CaseInsensitiveStringMap).equals = function (other) {
    var tmp;
    if (other instanceof CaseInsensitiveStringMap) {
      tmp = equals(this.po_1, other.po_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(CaseInsensitiveStringMap).hashCode = function () {
    return hashCode(this.po_1);
  };
  function toCaseInsensitiveMap(_this__u8e3s4) {
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = CaseInsensitiveStringMap_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.toCaseInsensitiveMap.<anonymous>' call
    tmp0_also.uo(_this__u8e3s4);
    tmp$ret$0 = tmp0_also;
    return tmp$ret$0;
  }
  function _get__data__kyoi3c($this) {
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.fastCastTo' call
    var tmp0_fastCastTo = $this.xo_1;
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_fastCastTo;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    return tmp$ret$2;
  }
  function _get_capacity__a9k9f3($this) {
    return $this.xo_1.length;
  }
  function TGenDeque_init_$Init$($this) {
    TGenDeque.call($this, 16);
    return $this;
  }
  function TGenDeque_init_$Create$() {
    return TGenDeque_init_$Init$(objectCreate(protoOf(TGenDeque)));
  }
  function resizeIfRequiredFor($this, count) {
    if (($this.j() + count | 0) > _get_capacity__a9k9f3($this)) {
      var i = $this.xo_1;
      var istart = $this.vo_1;
      var tmp$ret$2;
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp$ret$1;
      // Inline function 'kotlin.comparisons.maxOf' call
      var tmp2_maxOf = $this.xo_1.length + 7 | 0;
      var tmp$ret$0;
      // Inline function 'kotlin.comparisons.maxOf' call
      var tmp0_maxOf = $this.j() + count | 0;
      var tmp1_maxOf = imul($this.xo_1.length, 2);
      tmp$ret$0 = Math.max(tmp0_maxOf, tmp1_maxOf);
      var tmp3_maxOf = tmp$ret$0;
      tmp$ret$1 = Math.max(tmp2_maxOf, tmp3_maxOf);
      var tmp4_arrayOfNulls = tmp$ret$1;
      tmp$ret$2 = fillArrayVal(Array(tmp4_arrayOfNulls), null);
      var _o = tmp$ret$2;
      var o = isArray(_o) ? _o : THROW_CCE();
      copyCyclic($this, i, istart, o, $this.wo_1);
      $this.xo_1 = o;
      $this.vo_1 = 0;
    }
  }
  function copyCyclic($this, i, istart, o, count) {
    var tmp$ret$0;
    // Inline function 'kotlin.math.min' call
    var tmp0_min = i.length - istart | 0;
    tmp$ret$0 = Math.min(tmp0_min, count);
    var size1 = tmp$ret$0;
    var size2 = count - size1 | 0;
    arraycopy_3(i, istart, o, 0, size1);
    if (size2 > 0) {
      arraycopy_3(i, 0, o, size1, size2);
    }
  }
  function _addLast($this, item) {
    $this.xo_1[($this.vo_1 + $this.wo_1 | 0) % _get_capacity__a9k9f3($this) | 0] = item;
    var tmp0_this = $this;
    var tmp1 = tmp0_this.wo_1;
    tmp0_this.wo_1 = tmp1 + 1 | 0;
  }
  function nullify($this, index) {
    _get__data__kyoi3c($this)[index] = null;
  }
  function internalIndex($this, index) {
    return umod($this.vo_1 + index | 0, _get_capacity__a9k9f3($this));
  }
  function TGenDeque$iterator$1($that, this$0) {
    this.zo_1 = $that;
    this.ap_1 = this$0;
    this.yo_1 = 0;
  }
  protoOf(TGenDeque$iterator$1).i = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this.yo_1;
    tmp0_this.yo_1 = tmp1 + 1 | 0;
    return this.zo_1.k(tmp1);
  };
  protoOf(TGenDeque$iterator$1).h = function () {
    return this.yo_1 < this.ap_1.j();
  };
  protoOf(TGenDeque$iterator$1).y3 = function () {
    var tmp0_this = this;
    tmp0_this.yo_1 = tmp0_this.yo_1 - 1 | 0;
    this.ap_1.u2(tmp0_this.yo_1);
  };
  function TGenDeque(initialCapacity) {
    this.vo_1 = 0;
    this.wo_1 = 0;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp$ret$0 = fillArrayVal(Array(initialCapacity), null);
    var tmp_0 = tmp$ret$0;
    tmp.xo_1 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
  }
  protoOf(TGenDeque).j = function () {
    return this.wo_1;
  };
  protoOf(TGenDeque).l = function () {
    return this.j() === 0;
  };
  protoOf(TGenDeque).bp = function (item) {
    resizeIfRequiredFor(this, 1);
    _addLast(this, item);
  };
  protoOf(TGenDeque).cp = function (list) {
    var tmp$ret$1;
    // Inline function 'korlibs.datastructure.TGenDeque._addAll' call
    var tmp0__addAll = list.j();
    resizeIfRequiredFor(this, tmp0__addAll);
    var base = this.vo_1 + this.wo_1 | 0;
    var inductionVariable = 0;
    if (inductionVariable < tmp0__addAll)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.xo_1;
        var tmp_0 = (base + n | 0) % _get_capacity__a9k9f3(this) | 0;
        var tmp$ret$0;
        // Inline function 'korlibs.datastructure.TGenDeque.addAll.<anonymous>' call
        tmp$ret$0 = list.k(n);
        tmp[tmp_0] = tmp$ret$0;
      }
       while (inductionVariable < tmp0__addAll);
    var tmp1_this = this;
    tmp1_this.wo_1 = tmp1_this.wo_1 + tmp0__addAll | 0;
    tmp$ret$1 = true;
    return tmp$ret$1;
  };
  protoOf(TGenDeque).dp = function (elements) {
    return this.cp(toList(elements));
  };
  protoOf(TGenDeque).m = function (elements) {
    return this.dp(elements);
  };
  protoOf(TGenDeque).n2 = function () {
    if (this.wo_1 <= 0)
      throw IndexOutOfBoundsException_init_$Create$();
    var out = this.ep();
    nullify(this, this.vo_1);
    this.vo_1 = (this.vo_1 + 1 | 0) % _get_capacity__a9k9f3(this) | 0;
    var tmp0_this = this;
    var tmp1 = tmp0_this.wo_1;
    tmp0_this.wo_1 = tmp1 - 1 | 0;
    return out;
  };
  protoOf(TGenDeque).p2 = function () {
    if (this.wo_1 <= 0)
      throw IndexOutOfBoundsException_init_$Create$();
    var out = this.fp();
    nullify(this, internalIndex(this, this.j() - 1 | 0));
    var tmp0_this = this;
    var tmp1 = tmp0_this.wo_1;
    tmp0_this.wo_1 = tmp1 - 1 | 0;
    return out;
  };
  protoOf(TGenDeque).u2 = function (index) {
    if (index < 0 ? true : index >= this.j())
      throw IndexOutOfBoundsException_init_$Create$();
    if (index === 0)
      return this.n2();
    if (index === (this.j() - 1 | 0))
      return this.p2();
    var old = this.k(index);
    if (index < (this.j() / 2 | 0)) {
      var inductionVariable = index;
      if (1 <= inductionVariable)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          this.gp(n, this.k(n - 1 | 0));
        }
         while (1 <= inductionVariable);
      this.vo_1 = umod(this.vo_1 + 1 | 0, _get_capacity__a9k9f3(this));
    } else {
      var inductionVariable_0 = index;
      var last = this.j() - 1 | 0;
      if (inductionVariable_0 < last)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this.gp(n_0, this.k(n_0 + 1 | 0));
        }
         while (inductionVariable_0 < last);
    }
    var tmp2_this = this;
    var tmp3 = tmp2_this.wo_1;
    tmp2_this.wo_1 = tmp3 - 1 | 0;
    return old;
  };
  protoOf(TGenDeque).hp = function (element) {
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.TGenDeque.add.<anonymous>' call
    this.bp(element);
    tmp$ret$0 = true;
    return tmp$ret$0;
  };
  protoOf(TGenDeque).b = function (element) {
    return this.hp((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  protoOf(TGenDeque).ep = function () {
    return this.xo_1[this.vo_1];
  };
  protoOf(TGenDeque).fp = function () {
    return this.xo_1[internalIndex(this, this.j() - 1 | 0)];
  };
  protoOf(TGenDeque).gp = function (index, value) {
    this.xo_1[internalIndex(this, index)] = value;
  };
  protoOf(TGenDeque).k = function (index) {
    return this.xo_1[internalIndex(this, index)];
  };
  protoOf(TGenDeque).ip = function (elements) {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.map' call
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList_init_$Create$(collectionSizeOrDefault(elements, 10));
    var tmp0_iterator = elements.g();
    while (tmp0_iterator.h()) {
      var item = tmp0_iterator.i();
      var tmp$ret$0;
      // Inline function 'korlibs.datastructure.TGenDeque.containsAll.<anonymous>' call
      tmp$ret$0 = to(item, 0);
      tmp0_mapTo.b(tmp$ret$0);
    }
    tmp$ret$1 = tmp0_mapTo;
    tmp$ret$2 = tmp$ret$1;
    var emap = toLinkedMap(tmp$ret$2);
    var inductionVariable = 0;
    var last = this.j();
    if (inductionVariable < last)
      do {
        var it = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var e = this.k(it);
        var tmp$ret$4;
        // Inline function 'kotlin.collections.contains' call
        var tmp$ret$3;
        // Inline function 'kotlin.collections.containsKey' call
        tmp$ret$3 = (isInterface(emap, Map_0) ? emap : THROW_CCE()).v1(e);
        tmp$ret$4 = tmp$ret$3;
        if (tmp$ret$4) {
          // Inline function 'kotlin.collections.set' call
          emap.x3(e, 1);
        }
      }
       while (inductionVariable < last);
    var tmp$ret$5;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp1_all = emap.eb();
      var tmp;
      if (isInterface(tmp1_all, Collection)) {
        tmp = tmp1_all.l();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$5 = true;
        break $l$block_0;
      }
      var tmp0_iterator_0 = tmp1_all.g();
      while (tmp0_iterator_0.h()) {
        var element = tmp0_iterator_0.i();
        var tmp$ret$6;
        // Inline function 'korlibs.datastructure.TGenDeque.containsAll.<anonymous>' call
        tmp$ret$6 = element === 1;
        if (!tmp$ret$6) {
          tmp$ret$5 = false;
          break $l$block_0;
        }
      }
      tmp$ret$5 = true;
    }
    return tmp$ret$5;
  };
  protoOf(TGenDeque).h1 = function (elements) {
    return this.ip(elements);
  };
  protoOf(TGenDeque).g = function () {
    var that = this;
    return new TGenDeque$iterator$1(that, this);
  };
  protoOf(TGenDeque).hashCode = function () {
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.internal.contentHashCode' call
    var tmp1_contentHashCode = this.j();
    var result = 1;
    var inductionVariable = 0;
    if (inductionVariable < tmp1_contentHashCode)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = imul(31, result);
        var tmp$ret$1;
        // Inline function 'kotlin.hashCode' call
        var tmp$ret$0;
        // Inline function 'korlibs.datastructure.TGenDeque.hashCode.<anonymous>' call
        tmp$ret$0 = this.k(n);
        var tmp0_hashCode = tmp$ret$0;
        var tmp0_safe_receiver = tmp0_hashCode;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        tmp$ret$1 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        result = tmp + tmp$ret$1 | 0;
      }
       while (inductionVariable < tmp1_contentHashCode);
    tmp$ret$2 = result;
    return tmp$ret$2;
  };
  protoOf(TGenDeque).equals = function (other) {
    if (!(other instanceof TGenDeque))
      return false;
    if (!(other.j() === this.j()))
      return false;
    var inductionVariable = 0;
    var last = this.j();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!equals(this.k(n), other.k(n)))
          return false;
      }
       while (inductionVariable < last);
    return true;
  };
  protoOf(TGenDeque).toString = function () {
    var sb = StringBuilder_init_$Create$_0();
    sb.f7(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.j();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        sb.ue(this.k(n));
        if (!(n === (this.j() - 1 | 0))) {
          sb.ve(', ');
        }
      }
       while (inductionVariable < last);
    sb.f7(_Char___init__impl__6a9atx(93));
    return sb.toString();
  };
  function _get__data__kyoi3c_0($this) {
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.fastCastTo' call
    var tmp0_fastCastTo = $this.lp_1;
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_fastCastTo;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    return tmp$ret$2;
  }
  function _get_capacity__a9k9f3_0($this) {
    return $this.lp_1.length;
  }
  function resizeIfRequiredFor_0($this, count) {
    if (($this.j() + count | 0) > _get_capacity__a9k9f3_0($this)) {
      var i = $this.lp_1;
      var istart = $this.jp_1;
      var tmp$ret$1;
      // Inline function 'kotlin.comparisons.maxOf' call
      var tmp2_maxOf = $this.lp_1.length + 7 | 0;
      var tmp$ret$0;
      // Inline function 'kotlin.comparisons.maxOf' call
      var tmp0_maxOf = $this.j() + count | 0;
      var tmp1_maxOf = imul($this.lp_1.length, 2);
      tmp$ret$0 = Math.max(tmp0_maxOf, tmp1_maxOf);
      var tmp3_maxOf = tmp$ret$0;
      tmp$ret$1 = Math.max(tmp2_maxOf, tmp3_maxOf);
      var _o = new Int32Array(tmp$ret$1);
      var o = isIntArray(_o) ? _o : THROW_CCE();
      copyCyclic_0($this, i, istart, o, $this.kp_1);
      $this.lp_1 = o;
      $this.jp_1 = 0;
    }
  }
  function copyCyclic_0($this, i, istart, o, count) {
    var tmp$ret$0;
    // Inline function 'kotlin.math.min' call
    var tmp0_min = i.length - istart | 0;
    tmp$ret$0 = Math.min(tmp0_min, count);
    var size1 = tmp$ret$0;
    var size2 = count - size1 | 0;
    arraycopy_1(i, istart, o, 0, size1);
    if (size2 > 0) {
      arraycopy_1(i, 0, o, size1, size2);
    }
  }
  function _addLast_0($this, item) {
    $this.lp_1[($this.jp_1 + $this.kp_1 | 0) % _get_capacity__a9k9f3_0($this) | 0] = item;
    var tmp0_this = $this;
    var tmp1 = tmp0_this.kp_1;
    tmp0_this.kp_1 = tmp1 + 1 | 0;
  }
  function nullify_0($this, index) {
    _get__data__kyoi3c_0($this)[index] = 0;
  }
  function internalIndex_0($this, index) {
    return umod($this.jp_1 + index | 0, _get_capacity__a9k9f3_0($this));
  }
  function IntDeque$iterator$1($that, this$0) {
    this.np_1 = $that;
    this.op_1 = this$0;
    this.mp_1 = 0;
  }
  protoOf(IntDeque$iterator$1).i = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this.mp_1;
    tmp0_this.mp_1 = tmp1 + 1 | 0;
    return this.np_1.k(tmp1);
  };
  protoOf(IntDeque$iterator$1).h = function () {
    return this.mp_1 < this.op_1.j();
  };
  protoOf(IntDeque$iterator$1).y3 = function () {
    var tmp0_this = this;
    tmp0_this.mp_1 = tmp0_this.mp_1 - 1 | 0;
    this.op_1.u2(tmp0_this.mp_1);
  };
  function IntDeque(initialCapacity) {
    this.jp_1 = 0;
    this.kp_1 = 0;
    var tmp = this;
    var tmp_0 = new Int32Array(initialCapacity);
    tmp.lp_1 = isIntArray(tmp_0) ? tmp_0 : THROW_CCE();
  }
  protoOf(IntDeque).j = function () {
    return this.kp_1;
  };
  protoOf(IntDeque).l = function () {
    return this.j() === 0;
  };
  protoOf(IntDeque).pp = function (item) {
    resizeIfRequiredFor_0(this, 1);
    _addLast_0(this, item);
  };
  protoOf(IntDeque).qp = function (list) {
    var tmp$ret$1;
    // Inline function 'korlibs.datastructure.IntDeque._addAll' call
    var tmp0__addAll = list.j();
    resizeIfRequiredFor_0(this, tmp0__addAll);
    var base = this.jp_1 + this.kp_1 | 0;
    var inductionVariable = 0;
    if (inductionVariable < tmp0__addAll)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.lp_1;
        var tmp_0 = (base + n | 0) % _get_capacity__a9k9f3_0(this) | 0;
        var tmp$ret$0;
        // Inline function 'korlibs.datastructure.IntDeque.addAll.<anonymous>' call
        tmp$ret$0 = list.k(n);
        tmp[tmp_0] = tmp$ret$0;
      }
       while (inductionVariable < tmp0__addAll);
    var tmp1_this = this;
    tmp1_this.kp_1 = tmp1_this.kp_1 + tmp0__addAll | 0;
    tmp$ret$1 = true;
    return tmp$ret$1;
  };
  protoOf(IntDeque).rp = function (elements) {
    return this.qp(toList(elements));
  };
  protoOf(IntDeque).m = function (elements) {
    return this.rp(elements);
  };
  protoOf(IntDeque).n2 = function () {
    if (this.kp_1 <= 0)
      throw IndexOutOfBoundsException_init_$Create$();
    var out = this.ep();
    nullify_0(this, this.jp_1);
    this.jp_1 = (this.jp_1 + 1 | 0) % _get_capacity__a9k9f3_0(this) | 0;
    var tmp0_this = this;
    var tmp1 = tmp0_this.kp_1;
    tmp0_this.kp_1 = tmp1 - 1 | 0;
    return out;
  };
  protoOf(IntDeque).p2 = function () {
    if (this.kp_1 <= 0)
      throw IndexOutOfBoundsException_init_$Create$();
    var out = this.fp();
    nullify_0(this, internalIndex_0(this, this.j() - 1 | 0));
    var tmp0_this = this;
    var tmp1 = tmp0_this.kp_1;
    tmp0_this.kp_1 = tmp1 - 1 | 0;
    return out;
  };
  protoOf(IntDeque).u2 = function (index) {
    if (index < 0 ? true : index >= this.j())
      throw IndexOutOfBoundsException_init_$Create$();
    if (index === 0)
      return this.n2();
    if (index === (this.j() - 1 | 0))
      return this.p2();
    var old = this.k(index);
    if (index < (this.j() / 2 | 0)) {
      var inductionVariable = index;
      if (1 <= inductionVariable)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          this.yn(n, this.k(n - 1 | 0));
        }
         while (1 <= inductionVariable);
      this.jp_1 = umod(this.jp_1 + 1 | 0, _get_capacity__a9k9f3_0(this));
    } else {
      var inductionVariable_0 = index;
      var last = this.j() - 1 | 0;
      if (inductionVariable_0 < last)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this.yn(n_0, this.k(n_0 + 1 | 0));
        }
         while (inductionVariable_0 < last);
    }
    var tmp2_this = this;
    var tmp3 = tmp2_this.kp_1;
    tmp2_this.kp_1 = tmp3 - 1 | 0;
    return old;
  };
  protoOf(IntDeque).sp = function (element) {
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntDeque.add.<anonymous>' call
    this.pp(element);
    tmp$ret$0 = true;
    return tmp$ret$0;
  };
  protoOf(IntDeque).b = function (element) {
    return this.sp((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  };
  protoOf(IntDeque).ep = function () {
    return this.lp_1[this.jp_1];
  };
  protoOf(IntDeque).fp = function () {
    return this.lp_1[internalIndex_0(this, this.j() - 1 | 0)];
  };
  protoOf(IntDeque).yn = function (index, value) {
    this.lp_1[internalIndex_0(this, index)] = value;
  };
  protoOf(IntDeque).k = function (index) {
    return this.lp_1[internalIndex_0(this, index)];
  };
  protoOf(IntDeque).zn = function (elements) {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.map' call
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList_init_$Create$(collectionSizeOrDefault(elements, 10));
    var tmp0_iterator = elements.g();
    while (tmp0_iterator.h()) {
      var item = tmp0_iterator.i();
      var tmp$ret$0;
      // Inline function 'korlibs.datastructure.IntDeque.containsAll.<anonymous>' call
      tmp$ret$0 = to(item, 0);
      tmp0_mapTo.b(tmp$ret$0);
    }
    tmp$ret$1 = tmp0_mapTo;
    tmp$ret$2 = tmp$ret$1;
    var emap = toLinkedMap(tmp$ret$2);
    var inductionVariable = 0;
    var last = this.j();
    if (inductionVariable < last)
      do {
        var it = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var e = this.k(it);
        var tmp$ret$4;
        // Inline function 'kotlin.collections.contains' call
        var tmp$ret$3;
        // Inline function 'kotlin.collections.containsKey' call
        tmp$ret$3 = (isInterface(emap, Map_0) ? emap : THROW_CCE()).v1(e);
        tmp$ret$4 = tmp$ret$3;
        if (tmp$ret$4) {
          // Inline function 'kotlin.collections.set' call
          emap.x3(e, 1);
        }
      }
       while (inductionVariable < last);
    var tmp$ret$5;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp1_all = emap.eb();
      var tmp;
      if (isInterface(tmp1_all, Collection)) {
        tmp = tmp1_all.l();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$5 = true;
        break $l$block_0;
      }
      var tmp0_iterator_0 = tmp1_all.g();
      while (tmp0_iterator_0.h()) {
        var element = tmp0_iterator_0.i();
        var tmp$ret$6;
        // Inline function 'korlibs.datastructure.IntDeque.containsAll.<anonymous>' call
        tmp$ret$6 = element === 1;
        if (!tmp$ret$6) {
          tmp$ret$5 = false;
          break $l$block_0;
        }
      }
      tmp$ret$5 = true;
    }
    return tmp$ret$5;
  };
  protoOf(IntDeque).h1 = function (elements) {
    return this.zn(elements);
  };
  protoOf(IntDeque).g = function () {
    var that = this;
    return new IntDeque$iterator$1(that, this);
  };
  protoOf(IntDeque).hashCode = function () {
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.internal.contentHashCode' call
    var tmp1_contentHashCode = this.j();
    var result = 1;
    var inductionVariable = 0;
    if (inductionVariable < tmp1_contentHashCode)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = imul(31, result);
        var tmp$ret$1;
        // Inline function 'kotlin.hashCode' call
        var tmp$ret$0;
        // Inline function 'korlibs.datastructure.IntDeque.hashCode.<anonymous>' call
        tmp$ret$0 = this.k(n);
        var tmp0_hashCode = tmp$ret$0;
        var tmp0_safe_receiver = tmp0_hashCode;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        tmp$ret$1 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        result = tmp + tmp$ret$1 | 0;
      }
       while (inductionVariable < tmp1_contentHashCode);
    tmp$ret$2 = result;
    return tmp$ret$2;
  };
  protoOf(IntDeque).equals = function (other) {
    if (!(other instanceof IntDeque))
      return false;
    if (!(other.j() === this.j()))
      return false;
    var inductionVariable = 0;
    var last = this.j();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(this.k(n) === other.k(n)))
          return false;
      }
       while (inductionVariable < last);
    return true;
  };
  protoOf(IntDeque).toString = function () {
    var sb = StringBuilder_init_$Create$_0();
    sb.f7(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.j();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        sb.ue(this.k(n));
        if (!(n === (this.j() - 1 | 0))) {
          sb.ve(', ');
        }
      }
       while (inductionVariable < last);
    sb.f7(_Char___init__impl__6a9atx(93));
    return sb.toString();
  };
  function fastArrayListOf(values) {
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = FastArrayList_init_$Create$_0(values.length);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.fastArrayListOf.<anonymous>' call
    addAll(tmp0_also, values);
    tmp$ret$0 = tmp0_also;
    return tmp$ret$0;
  }
  function toFastList(_this__u8e3s4, out) {
    out = out === VOID ? FastArrayList_init_$Create$() : out;
    out.tp(0, _this__u8e3s4);
    out.wp(_this__u8e3s4.j());
    return out;
  }
  function MutableListEx() {
  }
  function toFastList_0(_this__u8e3s4) {
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = FastArrayList_init_$Create$_0(_this__u8e3s4.length);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.toFastList.<anonymous>' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < _this__u8e3s4.length) {
      // Inline function 'korlibs.datastructure.toFastList.<anonymous>.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var tmp0__anonymous__q1qw7t = _this__u8e3s4[tmp0];
      tmp0_also.b(tmp0__anonymous__q1qw7t);
    }
    tmp$ret$0 = tmp0_also;
    return tmp$ret$0;
  }
  function toMap_0(_this__u8e3s4) {
    var tmp$ret$4;
    // Inline function 'kotlin.also' call
    var tmp0_also = LinkedHashMap_init_$Create$_0(get_size_0(_this__u8e3s4));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.toMap.<anonymous>' call
    // Inline function 'korlibs.datastructure.fastForEachNullable' call
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = _this__u8e3s4;
    var mapIterator = tmp$ret$0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastForEachNullable.<anonymous>' call
      var tmp0__anonymous__q1qw7t = v.value;
      // Inline function 'korlibs.datastructure.toMap.<anonymous>.<anonymous>' call
      var tmp$ret$2;
      // Inline function 'korlibs.datastructure.get' call
      var tmp$ret$1;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$1 = _this__u8e3s4;
      tmp$ret$2 = tmp$ret$1.get(tmp0__anonymous__q1qw7t);
      var tmp1__anonymous__uwfjfc = tmp$ret$2;
      var tmp0_safe_receiver = tmp1__anonymous__uwfjfc;
      if (tmp0_safe_receiver == null)
        null;
      else {
        var tmp$ret$3;
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        tmp0_also.x3(tmp0__anonymous__q1qw7t, tmp1__anonymous__uwfjfc);
        tmp$ret$3 = Unit_getInstance();
      }
    }
    tmp$ret$4 = tmp0_also;
    return tmp$ret$4;
  }
  function getAndRemove(_this__u8e3s4, key) {
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = get(_this__u8e3s4, key);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.getAndRemove.<anonymous>' call
    remove(_this__u8e3s4, key);
    tmp$ret$0 = tmp0_also;
    return tmp$ret$0;
  }
  function get_keys(_this__u8e3s4) {
    return keys(_this__u8e3s4);
  }
  function FastSmallSet() {
    AbstractMutableSet.call(this);
    this.aq_1 = FastArrayList_init_$Create$();
    this.bq_1 = null;
    this.cq_1 = null;
    this.dq_1 = null;
  }
  protoOf(FastSmallSet).eq = function () {
    return this.aq_1;
  };
  protoOf(FastSmallSet).j = function () {
    return this.aq_1.j();
  };
  protoOf(FastSmallSet).g = function () {
    return this.aq_1.g();
  };
  protoOf(FastSmallSet).fq = function (element) {
    if (this.d1(element))
      return false;
    this.aq_1.b(element);
    return true;
  };
  protoOf(FastSmallSet).b = function (element) {
    return this.fq((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  protoOf(FastSmallSet).gq = function (element) {
    this.bq_1 = null;
    this.cq_1 = null;
    this.dq_1 = null;
    return this.aq_1.t2(element);
  };
  protoOf(FastSmallSet).d1 = function (element) {
    if ((element === this.bq_1 ? true : element === this.cq_1) ? true : element === this.bq_1)
      return true;
    var result = this.aq_1.g1(element);
    if (result) {
      this.cq_1 = this.bq_1;
      this.dq_1 = this.cq_1;
      this.bq_1 = element;
    }
    return result;
  };
  protoOf(FastSmallSet).g1 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    return this.d1((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  protoOf(FastSmallSet).v2 = function () {
    this.aq_1.v2();
    this.bq_1 = null;
    this.cq_1 = null;
    this.dq_1 = null;
  };
  function GenericListIterator(list, iindex) {
    iindex = iindex === VOID ? 0 : iindex;
    this.hq_1 = list;
    this.iq_1 = iindex;
    var containsUpper = this.hq_1.j();
    var containsArg = this.iq_1;
    if (!(0 <= containsArg ? containsArg < containsUpper : false))
      throw IndexOutOfBoundsException_init_$Create$_0('' + this.iq_1);
    this.jq_1 = this.iq_1;
  }
  protoOf(GenericListIterator).h = function () {
    return this.jq_1 < this.hq_1.j();
  };
  protoOf(GenericListIterator).i = function () {
    if (!this.h())
      throw NoSuchElementException_init_$Create$();
    var tmp0_this = this;
    var tmp1 = tmp0_this.jq_1;
    tmp0_this.jq_1 = tmp1 + 1 | 0;
    return this.hq_1.k(tmp1);
  };
  protoOf(GenericListIterator).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof GenericListIterator) {
      tmp_0 = equals(this.hq_1, other.hq_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.jq_1 === other.jq_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(GenericListIterator).hashCode = function () {
    return hashCode(this.hq_1) + this.jq_1 | 0;
  };
  function Companion_4() {
    Companion_instance_4 = this;
  }
  protoOf(Companion_4).bk = function (width, height, arraySize) {
    // Inline function 'kotlin.check' call
    var tmp0_check = arraySize >= imul(width, height);
    // Inline function 'kotlin.contracts.contract' call
    if (!tmp0_check) {
      var tmp$ret$0;
      // Inline function 'korlibs.datastructure.Companion.checkArraySize.<anonymous>' call
      tmp$ret$0 = 'backing array of size=' + arraySize + ', has less elements than ' + width + ' * ' + height;
      var message = tmp$ret$0;
      throw IllegalStateException_init_$Create$(toString(message));
    }
  };
  var Companion_instance_4;
  function Companion_getInstance_4() {
    if (Companion_instance_4 == null)
      new Companion_4();
    return Companion_instance_4;
  }
  function IArray2$asString$lambda(this$0) {
    return function (y) {
      var tmp$ret$2;
      // Inline function 'kotlin.collections.map' call
      var tmp1_map = until(0, this$0.ck());
      var tmp$ret$1;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo = ArrayList_init_$Create$(collectionSizeOrDefault(tmp1_map, 10));
      var inductionVariable = tmp1_map.a1_1;
      var last = tmp1_map.b1_1;
      if (inductionVariable <= last)
        do {
          var item = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp$ret$0;
          // Inline function 'korlibs.datastructure.IArray2.asString.<anonymous>.<anonymous>' call
          tmp$ret$0 = this$0.ik(item, y);
          tmp0_mapTo.b(tmp$ret$0);
        }
         while (!(item === last));
      tmp$ret$1 = tmp0_mapTo;
      tmp$ret$2 = tmp$ret$1;
      return joinToString(tmp$ret$2, ', ');
    };
  }
  function IArray2() {
  }
  function index(_this__u8e3s4, x, y) {
    if (!(0 <= x ? x < _this__u8e3s4.ck() : false) ? true : !(0 <= y ? y < _this__u8e3s4.dk() : false))
      throw IndexOutOfBoundsException_init_$Create$();
    return imul(y, _this__u8e3s4.ck()) + x | 0;
  }
  function IntIntMap_init_$Init$(initialCapacity, loadFactor, $this) {
    initialCapacity = initialCapacity === VOID ? 16 : initialCapacity;
    loadFactor = loadFactor === VOID ? 0.75 : loadFactor;
    var tmp$ret$0;
    // Inline function 'kotlin.math.max' call
    var tmp0_max = ilog2Ceil(initialCapacity);
    tmp$ret$0 = Math.max(4, tmp0_max);
    IntIntMap.call($this, tmp$ret$0, loadFactor, true);
    return $this;
  }
  function IntIntMap_init_$Create$(initialCapacity, loadFactor) {
    return IntIntMap_init_$Init$(initialCapacity, loadFactor, objectCreate(protoOf(IntIntMap)));
  }
  function Companion_5() {
    Companion_instance_5 = this;
    this.kq_1 = 2147483646;
    this.lq_1 = 2147483647;
    this.mq_1 = 0;
  }
  var Companion_instance_5;
  function Companion_getInstance_5() {
    if (Companion_instance_5 == null)
      new Companion_5();
    return Companion_instance_5;
  }
  function _get_stashStart__3psegu($this) {
    return $this.uq_1.length - $this.tq_1 | 0;
  }
  function grow($this) {
    var inc = $this.nq_1 < 20 ? 3 : 1;
    var newnbits = $this.nq_1 + inc | 0;
    var new_0 = new IntIntMap(newnbits, $this.oq_1, true);
    var inductionVariable = 0;
    var last = $this.uq_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var k = $this.uq_1[n];
        Companion_getInstance_5();
        if (!(k === 0)) {
          new_0.yq(k, $this.vq_1[n]);
        }
      }
       while (inductionVariable <= last);
    $this.nq_1 = new_0.nq_1;
    $this.pq_1 = new_0.pq_1;
    $this.sq_1 = new_0.sq_1;
    $this.tq_1 = new_0.tq_1;
    $this.uq_1 = new_0.uq_1;
    $this.vq_1 = new_0.vq_1;
    $this.wq_1 = new_0.wq_1;
  }
  function growStash($this) {
    $this.tq_1 = imul($this.tq_1, 2);
    $this.uq_1 = copyOf_1($this.uq_1, $this.zq());
    $this.vq_1 = copyOf_1($this.vq_1, $this.zq());
  }
  function _getKeyIndex($this, key) {
    if (key === 0) {
      var tmp;
      if ($this.qq_1) {
        Companion_getInstance_5();
        tmp = 2147483647;
      } else {
        tmp = -1;
      }
      return tmp;
    }
    var index1 = hash1($this, key);
    if ($this.uq_1[index1] === key)
      return index1;
    var index2 = hash2($this, key);
    if ($this.uq_1[index2] === key)
      return index2;
    var index3 = hash3($this, key);
    if ($this.uq_1[index3] === key)
      return index3;
    var inductionVariable = _get_stashStart__3psegu($this);
    var last = $this.uq_1.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if ($this.uq_1[n] === key)
          return n;
      }
       while (inductionVariable < last);
    return -1;
  }
  function setEmptySlot($this, index, key, value) {
    var tmp = $this.uq_1[index];
    Companion_getInstance_5();
    if (!(tmp === 0))
      throw IllegalStateException_init_$Create$_0();
    $this.uq_1[index] = key;
    $this.vq_1[index] = value;
    var tmp0_this = $this;
    var tmp1 = tmp0_this.xq_1;
    tmp0_this.xq_1 = tmp1 + 1 | 0;
    return 0;
  }
  function hash1($this, key) {
    return _hash1(key, $this.sq_1);
  }
  function hash2($this, key) {
    return _hash2(key, $this.sq_1);
  }
  function hash3($this, key) {
    return _hash3(key, $this.sq_1);
  }
  function IntIntMap(nbits, loadFactor, dummy) {
    Companion_getInstance_5();
    this.nq_1 = nbits;
    this.oq_1 = loadFactor;
    this.pq_1 = 1 << this.nq_1;
    this.qq_1 = false;
    this.rq_1 = 0;
    this.sq_1 = this.pq_1 - 1 | 0;
    this.tq_1 = 1 + imul(this.nq_1, this.nq_1) | 0;
    this.uq_1 = new Int32Array(this.zq());
    this.vq_1 = new Int32Array(this.zq());
    this.wq_1 = numberToInt(this.pq_1 * this.oq_1);
    this.xq_1 = 0;
  }
  protoOf(IntIntMap).toString = function () {
    return toString(this.ar());
  };
  protoOf(IntIntMap).zq = function () {
    return this.pq_1 + this.tq_1 | 0;
  };
  protoOf(IntIntMap).br = function (out) {
    // Inline function 'korlibs.datastructure.IntIntMap.fastForEach' call
    // Inline function 'korlibs.datastructure.IntIntMap.fastKeyForEach' call
    var tmp;
    if (this.qq_1) {
      Companion_getInstance_6();
      tmp = 2147483647;
    } else {
      tmp = this.cr(this.uq_1, 0);
    }
    var index = tmp;
    $l$loop: while (true) {
      var tmp_0 = index;
      Companion_getInstance_6();
      if (!!(tmp_0 === 2147483646)) {
        break $l$loop;
      }
      // Inline function 'korlibs.datastructure.IntIntMap.fastForEach.<anonymous>' call
      var tmp0_subject = index;
      var tmp_1;
      var tmp_2;
      Companion_getInstance_6();
      if (tmp0_subject === 2147483647) {
        tmp_2 = true;
      } else {
        Companion_getInstance_6();
        tmp_2 = tmp0_subject === 2147483646;
      }
      if (tmp_2) {
        tmp_1 = 0;
      } else {
        tmp_1 = this.uq_1[index];
      }
      var tmp0__anonymous__q1qw7t = tmp_1;
      // Inline function 'korlibs.datastructure.IntIntMap.toMap.<anonymous>' call
      var tmp1__anonymous__uwfjfc = this.k(tmp0__anonymous__q1qw7t);
      // Inline function 'kotlin.collections.set' call
      out.x3(tmp0__anonymous__q1qw7t, tmp1__anonymous__uwfjfc);
      var tmp_3 = this.uq_1;
      var tmp_4;
      var tmp_5 = index;
      Companion_getInstance_6();
      if (tmp_5 === 2147483647) {
        tmp_4 = 0;
      } else {
        tmp_4 = index + 1 | 0;
      }
      index = this.cr(tmp_3, tmp_4);
    }
    return out;
  };
  protoOf(IntIntMap).ar = function (out, $super) {
    out = out === VOID ? linkedHashMapOf([]) : out;
    return $super === VOID ? this.br(out) : $super.br.call(this, out);
  };
  protoOf(IntIntMap).l6 = function (key) {
    return _getKeyIndex(this, key) >= 0;
  };
  protoOf(IntIntMap).v2 = function () {
    this.qq_1 = false;
    this.rq_1 = 0;
    fill(this.uq_1, 0);
    fill(this.vq_1, 0);
    this.xq_1 = 0;
  };
  protoOf(IntIntMap).k = function (key) {
    var index = _getKeyIndex(this, key);
    if (index < 0)
      return 0;
    Companion_getInstance_5();
    if (index === 2147483647)
      return this.rq_1;
    return this.vq_1[index];
  };
  protoOf(IntIntMap).yq = function (key, value) {
    retry: while (true) {
      var index = _getKeyIndex(this, key);
      if (index < 0) {
        if (key === 0) {
          this.qq_1 = true;
          this.rq_1 = value;
          var tmp0_this = this;
          var tmp1 = tmp0_this.xq_1;
          tmp0_this.xq_1 = tmp1 + 1 | 0;
          return 0;
        }
        if (this.xq_1 >= this.wq_1) {
          grow(this);
        }
        var index1 = hash1(this, key);
        var tmp = this.uq_1[index1];
        Companion_getInstance_5();
        if (tmp === 0)
          return setEmptySlot(this, index1, key, value);
        var index2 = hash2(this, key);
        var tmp_0 = this.uq_1[index2];
        Companion_getInstance_5();
        if (tmp_0 === 0)
          return setEmptySlot(this, index2, key, value);
        var index3 = hash3(this, key);
        var tmp_1 = this.uq_1[index3];
        Companion_getInstance_5();
        if (tmp_1 === 0)
          return setEmptySlot(this, index3, key, value);
        var inductionVariable = _get_stashStart__3psegu(this);
        var last = this.uq_1.length;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp_2 = this.uq_1[n];
            Companion_getInstance_5();
            if (tmp_2 === 0)
              return setEmptySlot(this, n, key, value);
          }
           while (inductionVariable < last);
        if (this.tq_1 > 512) {
          grow(this);
        } else {
          growStash(this);
        }
        continue retry;
      } else {
        Companion_getInstance_5();
        if (index === 2147483647) {
          var tmp$ret$0;
          // Inline function 'kotlin.apply' call
          var tmp0_apply = this.rq_1;
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.datastructure.IntIntMap.set.<anonymous>' call
          this.rq_1 = value;
          tmp$ret$0 = tmp0_apply;
          return tmp$ret$0;
        } else {
          var tmp$ret$1;
          // Inline function 'kotlin.apply' call
          var tmp1_apply = this.vq_1[index];
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.datastructure.IntIntMap.set.<anonymous>' call
          this.vq_1[index] = value;
          tmp$ret$1 = tmp1_apply;
          return tmp$ret$1;
        }
      }
    }
  };
  protoOf(IntIntMap).cr = function (keys, offset) {
    var inductionVariable = offset;
    var last = keys.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = keys[n];
        Companion_getInstance_5();
        if (!(tmp === 0))
          return n;
      }
       while (inductionVariable < last);
    Companion_getInstance_5();
    return 2147483646;
  };
  protoOf(IntIntMap).equals = function (other) {
    if (!(other instanceof IntMap))
      return false;
    // Inline function 'korlibs.datastructure.IntIntMap.fastForEach' call
    // Inline function 'korlibs.datastructure.IntIntMap.fastKeyForEach' call
    var tmp;
    if (this.qq_1) {
      Companion_getInstance_6();
      tmp = 2147483647;
    } else {
      tmp = this.cr(this.uq_1, 0);
    }
    var index = tmp;
    $l$loop: while (true) {
      var tmp_0 = index;
      Companion_getInstance_6();
      if (!!(tmp_0 === 2147483646)) {
        break $l$loop;
      }
      // Inline function 'korlibs.datastructure.IntIntMap.fastForEach.<anonymous>' call
      var tmp0_subject = index;
      var tmp_1;
      var tmp_2;
      Companion_getInstance_6();
      if (tmp0_subject === 2147483647) {
        tmp_2 = true;
      } else {
        Companion_getInstance_6();
        tmp_2 = tmp0_subject === 2147483646;
      }
      if (tmp_2) {
        tmp_1 = 0;
      } else {
        tmp_1 = this.uq_1[index];
      }
      var tmp0__anonymous__q1qw7t = tmp_1;
      // Inline function 'korlibs.datastructure.IntIntMap.equals.<anonymous>' call
      var tmp1__anonymous__uwfjfc = this.k(tmp0__anonymous__q1qw7t);
      if (!equals(other.k(tmp0__anonymous__q1qw7t), tmp1__anonymous__uwfjfc))
        return false;
      var tmp_3 = this.uq_1;
      var tmp_4;
      var tmp_5 = index;
      Companion_getInstance_6();
      if (tmp_5 === 2147483647) {
        tmp_4 = 0;
      } else {
        tmp_4 = index + 1 | 0;
      }
      index = this.cr(tmp_3, tmp_4);
    }
    return true;
  };
  protoOf(IntIntMap).hashCode = function () {
    var out = 0;
    // Inline function 'korlibs.datastructure.IntIntMap.fastForEach' call
    // Inline function 'korlibs.datastructure.IntIntMap.fastKeyForEach' call
    var tmp;
    if (this.qq_1) {
      Companion_getInstance_6();
      tmp = 2147483647;
    } else {
      tmp = this.cr(this.uq_1, 0);
    }
    var index = tmp;
    $l$loop: while (true) {
      var tmp_0 = index;
      Companion_getInstance_6();
      if (!!(tmp_0 === 2147483646)) {
        break $l$loop;
      }
      // Inline function 'korlibs.datastructure.IntIntMap.fastForEach.<anonymous>' call
      var tmp0_subject = index;
      var tmp_1;
      var tmp_2;
      Companion_getInstance_6();
      if (tmp0_subject === 2147483647) {
        tmp_2 = true;
      } else {
        Companion_getInstance_6();
        tmp_2 = tmp0_subject === 2147483646;
      }
      if (tmp_2) {
        tmp_1 = 0;
      } else {
        tmp_1 = this.uq_1[index];
      }
      var tmp0__anonymous__q1qw7t = tmp_1;
      // Inline function 'korlibs.datastructure.IntIntMap.hashCode.<anonymous>' call
      var tmp1__anonymous__uwfjfc = this.k(tmp0__anonymous__q1qw7t);
      out = out + (tmp0__anonymous__q1qw7t + tmp1__anonymous__uwfjfc | 0) | 0;
      var tmp_3 = this.uq_1;
      var tmp_4;
      var tmp_5 = index;
      Companion_getInstance_6();
      if (tmp_5 === 2147483647) {
        tmp_4 = 0;
      } else {
        tmp_4 = index + 1 | 0;
      }
      index = this.cr(tmp_3, tmp_4);
    }
    return out;
  };
  function currentKey($this) {
    var tmp0_subject = $this.pr_1;
    var tmp;
    var tmp_0;
    Companion_getInstance_6();
    if (tmp0_subject === 2147483647) {
      tmp_0 = true;
    } else {
      Companion_getInstance_6();
      tmp_0 = tmp0_subject === 2147483646;
    }
    if (tmp_0) {
      tmp = 0;
    } else {
      tmp = $this.or_1.kr_1[$this.pr_1];
    }
    return tmp;
  }
  function currentValue($this) {
    var tmp0_subject = $this.pr_1;
    var tmp;
    Companion_getInstance_6();
    if (tmp0_subject === 2147483647) {
      tmp = $this.or_1.hr_1;
    } else {
      Companion_getInstance_6();
      if (tmp0_subject === 2147483646) {
        tmp = null;
      } else {
        tmp = $this.or_1.lr_1[$this.pr_1];
      }
    }
    return tmp;
  }
  function nextNonEmptyIndex($this, keys, offset) {
    var inductionVariable = offset;
    var last = keys.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = keys[n];
        Companion_getInstance_6();
        if (!(tmp === 0))
          return n;
      }
       while (inductionVariable < last);
    Companion_getInstance_6();
    return 2147483646;
  }
  function next($this) {
    var tmp = $this.pr_1;
    Companion_getInstance_6();
    if (!(tmp === 2147483646)) {
      var tmp_0 = $this;
      var tmp_1 = $this.or_1.kr_1;
      var tmp_2;
      var tmp_3 = $this.pr_1;
      Companion_getInstance_6();
      if (tmp_3 === 2147483647) {
        tmp_2 = 0;
      } else {
        tmp_2 = $this.pr_1 + 1 | 0;
      }
      tmp_0.pr_1 = nextNonEmptyIndex($this, tmp_1, tmp_2);
    }
  }
  function IntMap$_get_keys_$o$iterator$lambda_bn8atq($tmp0_let) {
    return function () {
      return $tmp0_let.h();
    };
  }
  function IntMap$_get_keys_$o$iterator$lambda_bn8atq_0($tmp0_let) {
    return function () {
      return $tmp0_let.rr();
    };
  }
  function IntMap$_get_values_$o$iterator$lambda_ggo058($tmp0_let) {
    return function () {
      return $tmp0_let.h();
    };
  }
  function IntMap$_get_values_$o$iterator$lambda_ggo058_0($tmp0_let) {
    return function () {
      return $tmp0_let.sr();
    };
  }
  function IntMap_init_$Init$(initialCapacity, loadFactor, $this) {
    initialCapacity = initialCapacity === VOID ? 16 : initialCapacity;
    loadFactor = loadFactor === VOID ? 0.75 : loadFactor;
    var tmp$ret$0;
    // Inline function 'kotlin.math.max' call
    var tmp0_max = ilog2Ceil(initialCapacity);
    tmp$ret$0 = Math.max(4, tmp0_max);
    IntMap.call($this, tmp$ret$0, loadFactor, true);
    return $this;
  }
  function IntMap_init_$Create$(initialCapacity, loadFactor) {
    return IntMap_init_$Init$(initialCapacity, loadFactor, objectCreate(protoOf(IntMap)));
  }
  function Companion_6() {
    Companion_instance_6 = this;
    this.tr_1 = 2147483646;
    this.ur_1 = 2147483647;
    this.vr_1 = 0;
  }
  var Companion_instance_6;
  function Companion_getInstance_6() {
    if (Companion_instance_6 == null)
      new Companion_6();
    return Companion_instance_6;
  }
  function _get_stashStart__3psegu_0($this) {
    return $this.kr_1.length - $this.jr_1 | 0;
  }
  function grow_0($this) {
    var inc = $this.dr_1 < 20 ? 3 : 1;
    var newnbits = $this.dr_1 + inc | 0;
    var new_0 = new IntMap(newnbits, $this.er_1, true);
    var inductionVariable = 0;
    var last = $this.kr_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var k = $this.kr_1[n];
        Companion_getInstance_6();
        if (!(k === 0)) {
          new_0.wr(k, $this.lr_1[n]);
        }
      }
       while (inductionVariable <= last);
    $this.dr_1 = new_0.dr_1;
    $this.fr_1 = new_0.fr_1;
    $this.ir_1 = new_0.ir_1;
    $this.jr_1 = new_0.jr_1;
    $this.kr_1 = new_0.kr_1;
    $this.lr_1 = new_0.lr_1;
    $this.mr_1 = new_0.mr_1;
  }
  function growStash_0($this) {
    $this.jr_1 = imul($this.jr_1, 2);
    $this.kr_1 = copyOf_1($this.kr_1, $this.zq());
    $this.lr_1 = copyOf_2($this.lr_1, $this.zq());
  }
  function _getKeyIndex_0($this, key) {
    if (key === 0) {
      var tmp;
      if ($this.gr_1) {
        Companion_getInstance_6();
        tmp = 2147483647;
      } else {
        tmp = -1;
      }
      return tmp;
    }
    var index1 = hash1_0($this, key);
    if ($this.kr_1[index1] === key)
      return index1;
    var index2 = hash2_0($this, key);
    if ($this.kr_1[index2] === key)
      return index2;
    var index3 = hash3_0($this, key);
    if ($this.kr_1[index3] === key)
      return index3;
    var inductionVariable = _get_stashStart__3psegu_0($this);
    var last = $this.kr_1.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if ($this.kr_1[n] === key)
          return n;
      }
       while (inductionVariable < last);
    return -1;
  }
  function setEmptySlot_0($this, index, key, value) {
    var tmp = $this.kr_1[index];
    Companion_getInstance_6();
    if (!(tmp === 0))
      throw IllegalStateException_init_$Create$_0();
    $this.kr_1[index] = key;
    $this.lr_1[index] = value;
    var tmp0_this = $this;
    var tmp1 = tmp0_this.nr_1;
    tmp0_this.nr_1 = tmp1 + 1 | 0;
    return null;
  }
  function hash1_0($this, key) {
    return _hash1(key, $this.ir_1);
  }
  function hash2_0($this, key) {
    return _hash2(key, $this.ir_1);
  }
  function hash3_0($this, key) {
    return _hash3(key, $this.ir_1);
  }
  function Entry(key, value) {
    this.xr_1 = key;
    this.yr_1 = value;
  }
  protoOf(Entry).toString = function () {
    return 'Entry(key=' + this.xr_1 + ', value=' + this.yr_1 + ')';
  };
  protoOf(Entry).hashCode = function () {
    var result = this.xr_1;
    result = imul(result, 31) + (this.yr_1 == null ? 0 : hashCode(this.yr_1)) | 0;
    return result;
  };
  protoOf(Entry).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry))
      return false;
    var tmp0_other_with_cast = other instanceof Entry ? other : THROW_CCE();
    if (!(this.xr_1 === tmp0_other_with_cast.xr_1))
      return false;
    if (!equals(this.yr_1, tmp0_other_with_cast.yr_1))
      return false;
    return true;
  };
  function Iterator(map) {
    this.or_1 = map;
    var tmp = this;
    var tmp_0;
    if (this.or_1.gr_1) {
      Companion_getInstance_6();
      tmp_0 = 2147483647;
    } else {
      tmp_0 = nextNonEmptyIndex(this, this.or_1.kr_1, 0);
    }
    tmp.pr_1 = tmp_0;
    this.qr_1 = new Entry(0, null);
  }
  protoOf(Iterator).h = function () {
    var tmp = this.pr_1;
    Companion_getInstance_6();
    return !(tmp === 2147483646);
  };
  protoOf(Iterator).rr = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = currentKey(this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.Iterator.nextKey.<anonymous>' call
    next(this);
    tmp$ret$0 = tmp0_apply;
    return tmp$ret$0;
  };
  protoOf(Iterator).sr = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = currentValue(this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.Iterator.nextValue.<anonymous>' call
    next(this);
    tmp$ret$0 = tmp0_apply;
    return tmp$ret$0;
  };
  function _no_name_provided__qut3iv(this$0) {
    this.zr_1 = this$0;
  }
  protoOf(_no_name_provided__qut3iv).g = function () {
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.IntMap.<get-keys>.<anonymous>' call
    var tmp$ret$1;
    // Inline function 'kotlin.let' call
    var tmp0_let = new Iterator(this.zr_1);
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$0;
    // Inline function 'korlibs.datastructure.IntMap.<get-keys>.<anonymous>.<anonymous>' call
    var tmp = IntMap$_get_keys_$o$iterator$lambda_bn8atq(tmp0_let);
    tmp$ret$0 = Iterator_0(tmp, IntMap$_get_keys_$o$iterator$lambda_bn8atq_0(tmp0_let));
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    return tmp$ret$2;
  };
  function _no_name_provided__qut3iv_0(this$0) {
    this.as_1 = this$0;
  }
  protoOf(_no_name_provided__qut3iv_0).g = function () {
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.IntMap.<get-values>.<anonymous>' call
    var tmp$ret$1;
    // Inline function 'kotlin.let' call
    var tmp0_let = new Iterator(this.as_1);
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$0;
    // Inline function 'korlibs.datastructure.IntMap.<get-values>.<anonymous>.<anonymous>' call
    var tmp = IntMap$_get_values_$o$iterator$lambda_ggo058(tmp0_let);
    tmp$ret$0 = Iterator_0(tmp, IntMap$_get_values_$o$iterator$lambda_ggo058_0(tmp0_let));
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    return tmp$ret$2;
  };
  function IntMap(nbits, loadFactor, dummy) {
    Companion_getInstance_6();
    dummy = dummy === VOID ? false : dummy;
    this.dr_1 = nbits;
    this.er_1 = loadFactor;
    this.fr_1 = 1 << this.dr_1;
    this.gr_1 = false;
    this.hr_1 = null;
    this.ir_1 = this.fr_1 - 1 | 0;
    this.jr_1 = 1 + imul(this.dr_1, this.dr_1) | 0;
    this.kr_1 = new Int32Array(this.zq());
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp0_arrayOfNulls = this.zq();
    tmp$ret$0 = fillArrayVal(Array(tmp0_arrayOfNulls), null);
    var tmp_0 = tmp$ret$0;
    tmp.lr_1 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
    this.mr_1 = numberToInt(this.fr_1 * this.er_1);
    this.nr_1 = 0;
  }
  protoOf(IntMap).zq = function () {
    return this.fr_1 + this.jr_1 | 0;
  };
  protoOf(IntMap).k = function (key) {
    var index = _getKeyIndex_0(this, key);
    if (index < 0)
      return null;
    Companion_getInstance_6();
    if (index === 2147483647)
      return this.hr_1;
    return this.lr_1[index];
  };
  protoOf(IntMap).wr = function (key, value) {
    retry: while (true) {
      var index = _getKeyIndex_0(this, key);
      if (index < 0) {
        if (key === 0) {
          this.gr_1 = true;
          this.hr_1 = value;
          var tmp0_this = this;
          var tmp1 = tmp0_this.nr_1;
          tmp0_this.nr_1 = tmp1 + 1 | 0;
          return null;
        }
        if (this.nr_1 >= this.mr_1) {
          grow_0(this);
        }
        var index1 = hash1_0(this, key);
        var tmp = this.kr_1[index1];
        Companion_getInstance_6();
        if (tmp === 0)
          return setEmptySlot_0(this, index1, key, value);
        var index2 = hash2_0(this, key);
        var tmp_0 = this.kr_1[index2];
        Companion_getInstance_6();
        if (tmp_0 === 0)
          return setEmptySlot_0(this, index2, key, value);
        var index3 = hash3_0(this, key);
        var tmp_1 = this.kr_1[index3];
        Companion_getInstance_6();
        if (tmp_1 === 0)
          return setEmptySlot_0(this, index3, key, value);
        var inductionVariable = _get_stashStart__3psegu_0(this);
        var last = this.kr_1.length;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp_2 = this.kr_1[n];
            Companion_getInstance_6();
            if (tmp_2 === 0)
              return setEmptySlot_0(this, n, key, value);
          }
           while (inductionVariable < last);
        if (this.jr_1 > 512) {
          grow_0(this);
        } else {
          growStash_0(this);
        }
        continue retry;
      } else {
        Companion_getInstance_6();
        if (index === 2147483647) {
          var tmp$ret$0;
          // Inline function 'kotlin.apply' call
          var tmp0_apply = this.hr_1;
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.datastructure.IntMap.set.<anonymous>' call
          this.hr_1 = value;
          tmp$ret$0 = tmp0_apply;
          return tmp$ret$0;
        } else {
          var tmp$ret$1;
          // Inline function 'kotlin.apply' call
          var tmp1_apply = this.lr_1[index];
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.datastructure.IntMap.set.<anonymous>' call
          this.lr_1[index] = value;
          tmp$ret$1 = tmp1_apply;
          return tmp$ret$1;
        }
      }
    }
  };
  protoOf(IntMap).a2 = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.collections.Iterable' call
    tmp$ret$0 = new _no_name_provided__qut3iv(this);
    return tmp$ret$0;
  };
  protoOf(IntMap).eb = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.collections.Iterable' call
    tmp$ret$0 = new _no_name_provided__qut3iv_0(this);
    return tmp$ret$0;
  };
  protoOf(IntMap).cr = function (keys, offset) {
    var inductionVariable = offset;
    var last = keys.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = keys[n];
        Companion_getInstance_6();
        if (!(tmp === 0))
          return n;
      }
       while (inductionVariable < last);
    Companion_getInstance_6();
    return 2147483646;
  };
  protoOf(IntMap).equals = function (other) {
    if (!(other instanceof IntMap))
      return false;
    // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable' call
    // Inline function 'korlibs.datastructure.IntMap.fastKeyForEach' call
    var tmp;
    if (this.gr_1) {
      Companion_getInstance_6();
      tmp = 2147483647;
    } else {
      tmp = this.cr(this.kr_1, 0);
    }
    var index = tmp;
    $l$loop: while (true) {
      var tmp_0 = index;
      Companion_getInstance_6();
      if (!!(tmp_0 === 2147483646)) {
        break $l$loop;
      }
      // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable.<anonymous>' call
      var tmp0_subject = index;
      var tmp_1;
      var tmp_2;
      Companion_getInstance_6();
      if (tmp0_subject === 2147483647) {
        tmp_2 = true;
      } else {
        Companion_getInstance_6();
        tmp_2 = tmp0_subject === 2147483646;
      }
      if (tmp_2) {
        tmp_1 = 0;
      } else {
        tmp_1 = this.kr_1[index];
      }
      var tmp0__anonymous__q1qw7t = tmp_1;
      // Inline function 'korlibs.datastructure.IntMap.equals.<anonymous>' call
      var tmp1__anonymous__uwfjfc = this.k(tmp0__anonymous__q1qw7t);
      if (!equals(other.k(tmp0__anonymous__q1qw7t), tmp1__anonymous__uwfjfc))
        return false;
      var tmp_3 = this.kr_1;
      var tmp_4;
      var tmp_5 = index;
      Companion_getInstance_6();
      if (tmp_5 === 2147483647) {
        tmp_4 = 0;
      } else {
        tmp_4 = index + 1 | 0;
      }
      index = this.cr(tmp_3, tmp_4);
    }
    return true;
  };
  protoOf(IntMap).hashCode = function () {
    var out = 0;
    // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable' call
    // Inline function 'korlibs.datastructure.IntMap.fastKeyForEach' call
    var tmp;
    if (this.gr_1) {
      Companion_getInstance_6();
      tmp = 2147483647;
    } else {
      tmp = this.cr(this.kr_1, 0);
    }
    var index = tmp;
    $l$loop: while (true) {
      var tmp_0 = index;
      Companion_getInstance_6();
      if (!!(tmp_0 === 2147483646)) {
        break $l$loop;
      }
      // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable.<anonymous>' call
      var tmp0_subject = index;
      var tmp_1;
      var tmp_2;
      Companion_getInstance_6();
      if (tmp0_subject === 2147483647) {
        tmp_2 = true;
      } else {
        Companion_getInstance_6();
        tmp_2 = tmp0_subject === 2147483646;
      }
      if (tmp_2) {
        tmp_1 = 0;
      } else {
        tmp_1 = this.kr_1[index];
      }
      var tmp0__anonymous__q1qw7t = tmp_1;
      // Inline function 'korlibs.datastructure.IntMap.hashCode.<anonymous>' call
      var tmp1__anonymous__uwfjfc = this.k(tmp0__anonymous__q1qw7t);
      var tmp_3 = out;
      var tmp_4 = tmp0__anonymous__q1qw7t;
      var tmp$ret$0;
      // Inline function 'kotlin.hashCode' call
      var tmp0_safe_receiver = tmp1__anonymous__uwfjfc;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
      tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      out = tmp_3 + (tmp_4 + tmp$ret$0 | 0) | 0;
      var tmp_5 = this.kr_1;
      var tmp_6;
      var tmp_7 = index;
      Companion_getInstance_6();
      if (tmp_7 === 2147483647) {
        tmp_6 = 0;
      } else {
        tmp_6 = index + 1 | 0;
      }
      index = this.cr(tmp_5, tmp_6);
    }
    return out;
  };
  function toIntMap(_this__u8e3s4) {
    var out = IntMap_init_$Create$(numberToInt(_this__u8e3s4.j() * 1.25));
    var tmp$ret$0;
    // Inline function 'kotlin.collections.iterator' call
    tmp$ret$0 = _this__u8e3s4.o().g();
    var tmp0_iterator = tmp$ret$0;
    while (tmp0_iterator.h()) {
      var tmp1_loop_parameter = tmp0_iterator.i();
      var tmp$ret$1;
      // Inline function 'kotlin.collections.component1' call
      tmp$ret$1 = tmp1_loop_parameter.p();
      var k = tmp$ret$1;
      var tmp$ret$2;
      // Inline function 'kotlin.collections.component2' call
      tmp$ret$2 = tmp1_loop_parameter.q();
      var v = tmp$ret$2;
      out.wr(k, v);
    }
    return out;
  }
  function _hash1(key, mask) {
    return _mask(key, mask);
  }
  function _hash2(key, mask) {
    return _mask(imul(key, 1294968109), mask);
  }
  function _hash3(key, mask) {
    return _mask(imul(key, 294969449), mask);
  }
  function _mask(value, mask) {
    return (((value + ((value >>> 8 | 0) & 255) | 0) + ((value >>> 16 | 0) & 255) | 0) + (value >> 24 & 255) | 0) & mask;
  }
  function associateByInt(_this__u8e3s4, block) {
    var n = 0;
    var out = IntMap_init_$Create$();
    var tmp0_iterator = _this__u8e3s4.g();
    while (tmp0_iterator.h()) {
      var it = tmp0_iterator.i();
      var tmp1 = n;
      n = tmp1 + 1 | 0;
      out.wr(block(tmp1, it), it);
    }
    return out;
  }
  function Iterator_0(hasNext, next) {
    return new Iterator$1(hasNext, next);
  }
  function Iterator$1($hasNext, $next) {
    this.bs_1 = $hasNext;
    this.cs_1 = $next;
  }
  protoOf(Iterator$1).h = function () {
    return this.bs_1();
  };
  protoOf(Iterator$1).i = function () {
    return this.cs_1();
  };
  function ListReader(list) {
    this.ds_1 = list;
    this.es_1 = 0;
  }
  protoOf(ListReader).fs = function () {
    return this.es_1 >= this.ds_1.j();
  };
  protoOf(ListReader).gs = function () {
    return this.es_1 < this.ds_1.j();
  };
  protoOf(ListReader).hs = function () {
    return this.ds_1.k(this.es_1);
  };
  protoOf(ListReader).fl = function (count) {
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.ListReader.skip.<anonymous>' call
    var tmp0_this = this;
    tmp0_this.es_1 = tmp0_this.es_1 + count | 0;
    tmp$ret$0 = this;
    return tmp$ret$0;
  };
  protoOf(ListReader).is = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = this.hs();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.ListReader.read.<anonymous>' call
    this.fl(1);
    tmp$ret$0 = tmp0_apply;
    return tmp$ret$0;
  };
  protoOf(ListReader).toString = function () {
    return 'ListReader(' + this.ds_1 + ')';
  };
  protoOf(ListReader).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof ListReader) {
      tmp_0 = equals(this.ds_1, other.ds_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.es_1 === other.es_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(ListReader).hashCode = function () {
    return hashCode(this.ds_1);
  };
  function Companion_7() {
    Companion_instance_7 = this;
  }
  var Companion_instance_7;
  function Companion_getInstance_7() {
    if (Companion_instance_7 == null)
      new Companion_7();
    return Companion_instance_7;
  }
  function Pool_init_$Init$(preallocate, gen, $this) {
    preallocate = preallocate === VOID ? 0 : preallocate;
    Pool.call($this, Pool$_init_$lambda_q3cbhr_0, preallocate, gen);
    return $this;
  }
  function Pool_init_$Create$(preallocate, gen) {
    return Pool_init_$Init$(preallocate, gen, objectCreate(protoOf(Pool)));
  }
  function Pool$_init_$lambda_q3cbhr(it) {
    return Unit_getInstance();
  }
  function Pool$_init_$lambda_q3cbhr_0(it) {
    return Unit_getInstance();
  }
  function Pool(reset, preallocate, gen) {
    Companion_getInstance_7();
    var tmp;
    if (reset === VOID) {
      tmp = Pool$_init_$lambda_q3cbhr;
    } else {
      tmp = reset;
    }
    reset = tmp;
    preallocate = preallocate === VOID ? 0 : preallocate;
    this.js_1 = reset;
    this.ks_1 = gen;
    this.ls_1 = _TGenStack___init__impl__yynjgt();
    this.ms_1 = 0;
    var inductionVariable = 0;
    if (inductionVariable < preallocate)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp1_this = this;
        var tmp2 = tmp1_this.ms_1;
        tmp1_this.ms_1 = tmp2 + 1 | 0;
        TGenStack__push_impl_9yh33t(this.ls_1, this.ks_1(tmp2));
      }
       while (inductionVariable < preallocate);
  }
  protoOf(Pool).ns = function () {
    return _TGenStack___get_size__impl__cvg66t(this.ls_1);
  };
  protoOf(Pool).os = function () {
    var tmp;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.isNotEmpty' call
    var tmp0_isNotEmpty = this.ls_1;
    tmp$ret$0 = !(new TGenStack(tmp0_isNotEmpty)).l();
    if (tmp$ret$0) {
      tmp = TGenStack__pop_impl_qisxa0(this.ls_1);
    } else {
      var tmp0_this = this;
      var tmp1 = tmp0_this.ms_1;
      tmp0_this.ms_1 = tmp1 + 1 | 0;
      tmp = this.ks_1(tmp1);
    }
    return tmp;
  };
  protoOf(Pool).v2 = function () {
    TGenStack__clear_impl_pali4s(this.ls_1);
    this.ms_1 = 0;
  };
  protoOf(Pool).ps = function (element) {
    this.js_1(element);
    TGenStack__push_impl_9yh33t(this.ls_1, element);
  };
  protoOf(Pool).qs = function (elements) {
    var tmp0_iterator = elements.g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      this.ps(element);
    }
  };
  protoOf(Pool).hashCode = function () {
    return TGenStack__hashCode_impl_l04zom(this.ls_1);
  };
  protoOf(Pool).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof Pool) {
      tmp_0 = equals(this.ls_1, other.ls_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.ns() === other.ns();
    } else {
      tmp = false;
    }
    return tmp;
  };
  function ConcurrentPool$_init_$lambda_gqhtk8(it) {
    return Unit_getInstance();
  }
  function ConcurrentPool(reset, preallocate, gen) {
    var tmp;
    if (reset === VOID) {
      tmp = ConcurrentPool$_init_$lambda_gqhtk8;
    } else {
      tmp = reset;
    }
    reset = tmp;
    preallocate = preallocate === VOID ? 0 : preallocate;
    Pool.call(this, reset, preallocate, gen);
    this.vs_1 = reset;
    this.ws_1 = gen;
    this.xs_1 = new NonRecursiveLock();
  }
  protoOf(ConcurrentPool).os = function () {
    var tmp$ret$1;
    // Inline function 'korlibs.datastructure.lock.NonRecursiveLock.invoke' call
    var tmp0_invoke = this.xs_1;
    var tmp$ret$0;
    // Inline function 'korlibs.datastructure.ConcurrentPool.alloc.<anonymous>' call
    tmp$ret$0 = protoOf(Pool).os.call(this);
    tmp$ret$1 = tmp$ret$0;
    return tmp$ret$1;
  };
  protoOf(ConcurrentPool).v2 = function () {
    var tmp$ret$0;
    // Inline function 'korlibs.datastructure.lock.NonRecursiveLock.invoke' call
    var tmp0_invoke = this.xs_1;
    protoOf(Pool).v2.call(this);
    tmp$ret$0 = Unit_getInstance();
  };
  protoOf(ConcurrentPool).ps = function (element) {
    var tmp$ret$0;
    // Inline function 'korlibs.datastructure.lock.NonRecursiveLock.invoke' call
    var tmp0_invoke = this.xs_1;
    protoOf(Pool).ps.call(this, element);
    tmp$ret$0 = Unit_getInstance();
  };
  function ReturnablePool$_init_$lambda_rsm60r(it) {
    return Unit_getInstance();
  }
  function ReturnablePool$list$lambda(this$0) {
    return function (it) {
      this$0.ys_1(it);
      return Unit_getInstance();
    };
  }
  function ReturnablePool$list$lambda_0(this$0) {
    return function (it) {
      return this$0.zs_1(it);
    };
  }
  function ReturnablePool(_reset, gen) {
    var tmp;
    if (_reset === VOID) {
      tmp = ReturnablePool$_init_$lambda_rsm60r;
    } else {
      tmp = _reset;
    }
    _reset = tmp;
    this.ys_1 = _reset;
    this.zs_1 = gen;
    this.at_1 = fastArrayListOf([]);
    var tmp_0 = this;
    var tmp_1 = ReturnablePool$list$lambda(this);
    tmp_0.bt_1 = new Pool(tmp_1, VOID, ReturnablePool$list$lambda_0(this));
    this.ct_1 = this.bt_1.os();
  }
  protoOf(ReturnablePool).i = function () {
    var tmp0_this = this;
    // Inline function 'kotlin.collections.plusAssign' call
    var tmp0_plusAssign = tmp0_this.at_1;
    var tmp1_plusAssign = this.ct_1;
    tmp0_plusAssign.b(tmp1_plusAssign);
    this.ct_1 = this.bt_1.os();
    return this.ct_1;
  };
  protoOf(ReturnablePool).dt = function () {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    var tmp3_fastForEach = this.at_1;
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = tmp3_fastForEach.vp_1;
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_unsafeCast;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    var array = tmp$ret$2;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.datastructure.ReturnablePool.reset.<anonymous>' call
      var tmp$ret$6;
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$4;
      // Inline function 'korlibs.datastructure.get' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var tmp1_get = tmp0;
      var tmp$ret$3;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$3 = array;
      tmp$ret$4 = tmp$ret$3[tmp1_get];
      var tmp2_unsafeCast = tmp$ret$4;
      var tmp$ret$5;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$5 = tmp2_unsafeCast;
      tmp$ret$6 = tmp$ret$5;
      var tmp4__anonymous__pkmkx7 = tmp$ret$6;
      this.bt_1.ps(tmp4__anonymous__pkmkx7);
    }
    this.at_1.v2();
  };
  function sam$kotlin_Comparator$0(function_0) {
    this.et_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0).t4 = function (a, b) {
    return this.et_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
    return this.t4(a, b);
  };
  function Companion_8() {
    Companion_instance_8 = this;
  }
  protoOf(Companion_8).ft = function (comparator, reversed_0) {
    var tmp$ret$0;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp$ret$0 = fillArrayVal(Array(16), null);
    var tmp = tmp$ret$0;
    return new TGenPriorityQueue(isArray(tmp) ? tmp : THROW_CCE(), reversed_0 ? reversed(comparator) : comparator);
  };
  protoOf(Companion_8).gt = function (reversed, comparator) {
    return Companion_getInstance_8().ft(new sam$kotlin_Comparator$0(comparator), reversed);
  };
  protoOf(Companion_8).ht = function (reversed, comparator, $super) {
    reversed = reversed === VOID ? false : reversed;
    return $super === VOID ? this.gt(reversed, comparator) : $super.gt.call(this, reversed, comparator);
  };
  var Companion_instance_8;
  function Companion_getInstance_8() {
    if (Companion_instance_8 == null)
      new Companion_8();
    return Companion_instance_8;
  }
  function _set_value__lx0xdg(_this__u8e3s4, $this, value) {
    $this.it_1[_this__u8e3s4] = value;
  }
  function _get_value__a43j40(_this__u8e3s4, $this) {
    return $this.it_1[_this__u8e3s4];
  }
  function _get_isRoot__1006zj(_this__u8e3s4, $this) {
    return _this__u8e3s4 === 0;
  }
  function _get_parent__oo9xup(_this__u8e3s4, $this) {
    return (_this__u8e3s4 - 1 | 0) / 2 | 0;
  }
  function _get_left__d9qyp0(_this__u8e3s4, $this) {
    return imul(2, _this__u8e3s4) + 1 | 0;
  }
  function _get_right__bvz45n(_this__u8e3s4, $this) {
    return imul(2, _this__u8e3s4) + 2 | 0;
  }
  function gt($this, a, b) {
    return $this.jt_1.compare(a, b) > 0;
  }
  function lt($this, a, b) {
    return $this.jt_1.compare(a, b) < 0;
  }
  function _get_capacity__a9k9f3_1($this) {
    return $this.it_1.length;
  }
  function ensure_1($this, index) {
    if (index >= _get_capacity__a9k9f3_1($this)) {
      var tmp = $this;
      var tmp_0 = copyOf_2($this.it_1, 2 + imul(_get_capacity__a9k9f3_1($this), 2) | 0);
      tmp.it_1 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
    }
  }
  function minHeapify($this, index) {
    var i = index;
    $l$loop: while (true) {
      var left = _get_left__d9qyp0(i, $this);
      var right = _get_right__bvz45n(i, $this);
      var smallest = i;
      if (left < $this.kt_1 ? lt($this, _get_value__a43j40(left, $this), _get_value__a43j40(i, $this)) : false)
        smallest = left;
      if (right < $this.kt_1 ? lt($this, _get_value__a43j40(right, $this), _get_value__a43j40(smallest, $this)) : false)
        smallest = right;
      if (!(smallest === i)) {
        swap_0($this, i, smallest);
        i = smallest;
      } else {
        break $l$loop;
      }
    }
  }
  function swap_0($this, l, r) {
    var temp = _get_value__a43j40(r, $this);
    _set_value__lx0xdg(r, $this, _get_value__a43j40(l, $this));
    _set_value__lx0xdg(l, $this, temp);
  }
  function TGenPriorityQueue$iterator$1($index, this$0) {
    this.lt_1 = $index;
    this.mt_1 = this$0;
  }
  protoOf(TGenPriorityQueue$iterator$1).h = function () {
    return this.lt_1._v < this.mt_1.kt_1;
  };
  protoOf(TGenPriorityQueue$iterator$1).i = function () {
    var tmp0 = this.lt_1._v;
    this.lt_1._v = tmp0 + 1 | 0;
    return _get_value__a43j40(tmp0, this.mt_1);
  };
  protoOf(TGenPriorityQueue$iterator$1).nt = function () {
    throw new NotImplementedError();
  };
  protoOf(TGenPriorityQueue$iterator$1).y3 = function () {
    return this.nt();
  };
  function TGenPriorityQueue(data, comparator) {
    Companion_getInstance_8();
    this.it_1 = data;
    this.jt_1 = comparator;
    this.kt_1 = 0;
  }
  protoOf(TGenPriorityQueue).j = function () {
    return this.kt_1;
  };
  protoOf(TGenPriorityQueue).ot = function () {
    if (this.kt_1 <= 0)
      throw IndexOutOfBoundsException_init_$Create$();
    return this.it_1[0];
  };
  protoOf(TGenPriorityQueue).hp = function (element) {
    var tmp0_this = this;
    var tmp1 = tmp0_this.kt_1;
    tmp0_this.kt_1 = tmp1 + 1 | 0;
    ensure_1(this, this.kt_1);
    var i = this.kt_1 - 1 | 0;
    _set_value__lx0xdg(i, this, element);
    while (!_get_isRoot__1006zj(i, this) ? gt(this, _get_value__a43j40(_get_parent__oo9xup(i, this), this), _get_value__a43j40(i, this)) : false) {
      swap_0(this, i, _get_parent__oo9xup(i, this));
      i = _get_parent__oo9xup(i, this);
    }
    return true;
  };
  protoOf(TGenPriorityQueue).b = function (element) {
    return this.hp((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  protoOf(TGenPriorityQueue).pt = function () {
    if (this.kt_1 <= 0)
      throw IndexOutOfBoundsException_init_$Create$();
    if (this.kt_1 === 1) {
      var tmp0_this = this;
      var tmp1 = tmp0_this.kt_1;
      tmp0_this.kt_1 = tmp1 - 1 | 0;
      return _get_value__a43j40(0, this);
    }
    var root = _get_value__a43j40(0, this);
    _set_value__lx0xdg(0, this, _get_value__a43j40(this.kt_1 - 1 | 0, this));
    var tmp2_this = this;
    var tmp3 = tmp2_this.kt_1;
    tmp2_this.kt_1 = tmp3 - 1 | 0;
    minHeapify(this, 0);
    return root;
  };
  protoOf(TGenPriorityQueue).qt = function (element) {
    var inductionVariable = 0;
    var last = this.kt_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(this.it_1[n], element))
          return n;
      }
       while (inductionVariable < last);
    return -1;
  };
  protoOf(TGenPriorityQueue).rt = function (element) {
    var index = this.qt(element);
    if (index >= 0) {
      this.st(index);
    }
    return index >= 0;
  };
  protoOf(TGenPriorityQueue).st = function (index) {
    var i = index;
    while (!(i === 0)) {
      swap_0(this, i, _get_parent__oo9xup(i, this));
      i = _get_parent__oo9xup(i, this);
    }
    this.pt();
  };
  protoOf(TGenPriorityQueue).ip = function (elements) {
    var thisSet = toSet(this);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.l();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = elements.g();
      while (tmp0_iterator.h()) {
        var element = tmp0_iterator.i();
        var tmp$ret$1;
        // Inline function 'korlibs.datastructure.TGenPriorityQueue.containsAll.<anonymous>' call
        tmp$ret$1 = thisSet.g1(element);
        if (!tmp$ret$1) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(TGenPriorityQueue).h1 = function (elements) {
    return this.ip(elements);
  };
  protoOf(TGenPriorityQueue).l = function () {
    return this.kt_1 === 0;
  };
  protoOf(TGenPriorityQueue).dp = function (elements) {
    var tmp0_iterator = elements.g();
    while (tmp0_iterator.h()) {
      var e = tmp0_iterator.i();
      this.hp(e);
    }
    var tmp$ret$0;
    // Inline function 'kotlin.collections.isNotEmpty' call
    tmp$ret$0 = !elements.l();
    return tmp$ret$0;
  };
  protoOf(TGenPriorityQueue).m = function (elements) {
    return this.dp(elements);
  };
  protoOf(TGenPriorityQueue).g = function () {
    var index = {_v: 0};
    return new TGenPriorityQueue$iterator$1(index, this);
  };
  protoOf(TGenPriorityQueue).toString = function () {
    return toString(toList(this));
  };
  protoOf(TGenPriorityQueue).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof TGenPriorityQueue) {
      tmp_0 = contentEquals_1(this.it_1, other.it_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.jt_1, other.jt_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(TGenPriorityQueue).hashCode = function () {
    return contentHashCode_1(this.it_1);
  };
  function TGenQueue() {
    this.tt_1 = TGenDeque_init_$Create$();
  }
  protoOf(TGenQueue).j = function () {
    return this.tt_1.j();
  };
  protoOf(TGenQueue).l = function () {
    return this.j() === 0;
  };
  protoOf(TGenQueue).ut = function (v) {
    this.tt_1.bp(v);
  };
  protoOf(TGenQueue).vt = function () {
    return this.tt_1.n2();
  };
  protoOf(TGenQueue).ip = function (elements) {
    return this.tt_1.ip(elements);
  };
  protoOf(TGenQueue).h1 = function (elements) {
    return this.ip(elements);
  };
  protoOf(TGenQueue).g = function () {
    return this.tt_1.g();
  };
  protoOf(TGenQueue).hashCode = function () {
    return this.tt_1.hashCode();
  };
  protoOf(TGenQueue).equals = function (other) {
    var tmp;
    if (other instanceof TGenQueue) {
      tmp = this.tt_1.equals(other.tt_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function Ref(value) {
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = Ref_0();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.Ref.<anonymous>' call
    tmp0_also.wt(value);
    tmp$ret$0 = tmp0_also;
    return tmp$ret$0;
  }
  function toRef(_this__u8e3s4) {
    return Ref_1(_this__u8e3s4);
  }
  function Ref_0() {
    return new Ref$2();
  }
  function Ref_1(prop) {
    return new Ref$3(prop);
  }
  function Ref$2() {
  }
  protoOf(Ref$2).wt = function (_set____db54di) {
    this.xt_1 = _set____db54di;
  };
  protoOf(Ref$2).q = function () {
    var tmp = this.xt_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('value');
    }
  };
  function Ref$3($prop) {
    this.yt_1 = $prop;
  }
  protoOf(Ref$3).wt = function (value) {
    this.yt_1.set(value);
  };
  protoOf(Ref$3).q = function () {
    return this.yt_1.get();
  };
  function RingBuffer(bits) {
    ByteRingBuffer.call(this, bits);
  }
  function ShortRingBuffer(bits) {
    this.il_1 = bits;
    this.jl_1 = 1 << this.il_1;
    this.kl_1 = this.jl_1 - 1 | 0;
    this.ll_1 = new Int16Array(this.jl_1);
    this.ml_1 = 0;
    this.nl_1 = 0;
    this.ol_1 = this.jl_1;
    this.pl_1 = 0;
    this.ql_1 = new Int16Array(1);
  }
  protoOf(ShortRingBuffer).xl = function (data, offset, size) {
    var tmp$ret$0;
    // Inline function 'kotlin.math.min' call
    var tmp0_min = this.ol_1;
    tmp$ret$0 = Math.min(tmp0_min, size);
    var toWrite = tmp$ret$0;
    var inductionVariable = 0;
    if (inductionVariable < toWrite)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.ll_1[this.nl_1] = data[offset + n | 0];
        this.nl_1 = (this.nl_1 + 1 | 0) & this.kl_1;
      }
       while (inductionVariable < toWrite);
    var tmp1_this = this;
    tmp1_this.pl_1 = tmp1_this.pl_1 + toWrite | 0;
    var tmp2_this = this;
    tmp2_this.ol_1 = tmp2_this.ol_1 - toWrite | 0;
    return toWrite;
  };
  protoOf(ShortRingBuffer).wl = function (data, offset, size) {
    var tmp$ret$0;
    // Inline function 'kotlin.math.min' call
    var tmp0_min = this.pl_1;
    tmp$ret$0 = Math.min(tmp0_min, size);
    var toRead = tmp$ret$0;
    var inductionVariable = 0;
    if (inductionVariable < toRead)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        data[offset + n | 0] = this.ll_1[this.ml_1];
        this.ml_1 = (this.ml_1 + 1 | 0) & this.kl_1;
      }
       while (inductionVariable < toRead);
    var tmp1_this = this;
    tmp1_this.ol_1 = tmp1_this.ol_1 + toRead | 0;
    var tmp2_this = this;
    tmp2_this.pl_1 = tmp2_this.pl_1 - toRead | 0;
    return toRead;
  };
  protoOf(ShortRingBuffer).v2 = function () {
    this.ml_1 = 0;
    this.nl_1 = 0;
    this.pl_1 = 0;
    this.ol_1 = this.jl_1;
  };
  protoOf(ShortRingBuffer).hu = function (offset) {
    return this.ll_1[(this.ml_1 + offset | 0) & this.kl_1];
  };
  protoOf(ShortRingBuffer).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof ShortRingBuffer) {
      tmp_0 = this.pl_1 === other.pl_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'korlibs.datastructure.internal.equaler' call
        var tmp0_equaler = this.pl_1;
        var inductionVariable = 0;
        if (inductionVariable < tmp0_equaler)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp$ret$0;
            // Inline function 'korlibs.datastructure.ShortRingBuffer.equals.<anonymous>' call
            tmp$ret$0 = this.hu(n) === other.hu(n);
            if (!tmp$ret$0) {
              tmp$ret$1 = false;
              break $l$block;
            }
          }
           while (inductionVariable < tmp0_equaler);
        tmp$ret$1 = true;
      }
      tmp = tmp$ret$1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(ShortRingBuffer).hashCode = function () {
    return this.hl();
  };
  protoOf(ShortRingBuffer).hl = function () {
    var tmp$ret$1;
    // Inline function 'korlibs.datastructure.internal.hashCoder' call
    var tmp0_hashCoder = this.pl_1;
    var out = 0;
    var inductionVariable = 0;
    if (inductionVariable < tmp0_hashCoder)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out = imul(out, 7);
        var tmp = out;
        var tmp$ret$0;
        // Inline function 'korlibs.datastructure.ShortRingBuffer.contentHashCode.<anonymous>' call
        tmp$ret$0 = this.hu(n);
        out = tmp + tmp$ret$0 | 0;
      }
       while (inductionVariable < tmp0_hashCoder);
    tmp$ret$1 = out;
    return tmp$ret$1;
  };
  function FloatRingBuffer(bits) {
    this.zl_1 = bits;
    this.am_1 = 1 << this.zl_1;
    this.bm_1 = this.am_1 - 1 | 0;
    this.cm_1 = new Float32Array(this.am_1);
    this.dm_1 = 0;
    this.em_1 = 0;
    this.fm_1 = this.am_1;
    this.gm_1 = 0;
  }
  protoOf(FloatRingBuffer).nm = function (data, offset, size) {
    var tmp$ret$0;
    // Inline function 'kotlin.math.min' call
    var tmp0_min = this.fm_1;
    tmp$ret$0 = Math.min(tmp0_min, size);
    var toWrite = tmp$ret$0;
    var inductionVariable = 0;
    if (inductionVariable < toWrite)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.cm_1[this.em_1] = data[offset + n | 0];
        this.em_1 = (this.em_1 + 1 | 0) & this.bm_1;
      }
       while (inductionVariable < toWrite);
    var tmp1_this = this;
    tmp1_this.gm_1 = tmp1_this.gm_1 + toWrite | 0;
    var tmp2_this = this;
    tmp2_this.fm_1 = tmp2_this.fm_1 - toWrite | 0;
    return toWrite;
  };
  protoOf(FloatRingBuffer).mm = function (data, offset, size) {
    var tmp$ret$0;
    // Inline function 'kotlin.math.min' call
    var tmp0_min = this.gm_1;
    tmp$ret$0 = Math.min(tmp0_min, size);
    var toRead = tmp$ret$0;
    var inductionVariable = 0;
    if (inductionVariable < toRead)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        data[offset + n | 0] = this.cm_1[this.dm_1];
        this.dm_1 = (this.dm_1 + 1 | 0) & this.bm_1;
      }
       while (inductionVariable < toRead);
    var tmp1_this = this;
    tmp1_this.fm_1 = tmp1_this.fm_1 + toRead | 0;
    var tmp2_this = this;
    tmp2_this.gm_1 = tmp2_this.gm_1 - toRead | 0;
    return toRead;
  };
  protoOf(FloatRingBuffer).hu = function (offset) {
    return this.cm_1[(this.dm_1 + offset | 0) & this.bm_1];
  };
  protoOf(FloatRingBuffer).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof FloatRingBuffer) {
      tmp_0 = this.gm_1 === other.gm_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'korlibs.datastructure.internal.equaler' call
        var tmp0_equaler = this.gm_1;
        var inductionVariable = 0;
        if (inductionVariable < tmp0_equaler)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp$ret$0;
            // Inline function 'korlibs.datastructure.FloatRingBuffer.equals.<anonymous>' call
            tmp$ret$0 = this.hu(n) === other.hu(n);
            if (!tmp$ret$0) {
              tmp$ret$1 = false;
              break $l$block;
            }
          }
           while (inductionVariable < tmp0_equaler);
        tmp$ret$1 = true;
      }
      tmp = tmp$ret$1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(FloatRingBuffer).hashCode = function () {
    return this.hl();
  };
  protoOf(FloatRingBuffer).hl = function () {
    var tmp$ret$1;
    // Inline function 'korlibs.datastructure.internal.hashCoder' call
    var tmp0_hashCoder = this.gm_1;
    var out = 0;
    var inductionVariable = 0;
    if (inductionVariable < tmp0_hashCoder)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out = imul(out, 7);
        var tmp = out;
        var tmp$ret$0;
        // Inline function 'korlibs.datastructure.FloatRingBuffer.contentHashCode.<anonymous>' call
        tmp$ret$0 = toBits(this.hu(n));
        out = tmp + tmp$ret$0 | 0;
      }
       while (inductionVariable < tmp0_hashCoder);
    tmp$ret$1 = out;
    return tmp$ret$1;
  };
  function ByteRingBuffer(bits) {
    this.nk_1 = bits;
    this.ok_1 = 1 << this.nk_1;
    this.pk_1 = this.ok_1 - 1 | 0;
    this.qk_1 = new Int8Array(this.ok_1);
    this.rk_1 = 0;
    this.sk_1 = 0;
    this.tk_1 = this.ok_1;
    this.uk_1 = 0;
  }
  protoOf(ByteRingBuffer).zt = function () {
    return this.qk_1;
  };
  protoOf(ByteRingBuffer).au = function () {
    return this.rk_1 & this.pk_1;
  };
  protoOf(ByteRingBuffer).bu = function () {
    return this.sk_1 & this.pk_1;
  };
  protoOf(ByteRingBuffer).cu = function (count) {
    if (count < 0 ? true : count > this.tk_1) {
      // Inline function 'kotlin.error' call
      throw IllegalStateException_init_$Create$('Try to write more than available');
    }
    var tmp0_this = this;
    tmp0_this.sk_1 = tmp0_this.sk_1 + count | 0;
    var tmp1_this = this;
    tmp1_this.uk_1 = tmp1_this.uk_1 + count | 0;
    var tmp2_this = this;
    tmp2_this.tk_1 = tmp2_this.tk_1 - count | 0;
  };
  protoOf(ByteRingBuffer).du = function (count) {
    if (count < 0 ? true : count > this.uk_1) {
      // Inline function 'kotlin.error' call
      throw IllegalStateException_init_$Create$('Try to write more than available');
    }
    var tmp0_this = this;
    tmp0_this.rk_1 = tmp0_this.rk_1 + count | 0;
    var tmp1_this = this;
    tmp1_this.uk_1 = tmp1_this.uk_1 - count | 0;
    var tmp2_this = this;
    tmp2_this.tk_1 = tmp2_this.tk_1 + count | 0;
  };
  protoOf(ByteRingBuffer).eu = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.math.min' call
    var tmp0_min = this.uk_1;
    var tmp1_min = this.ok_1 - (this.rk_1 & this.pk_1) | 0;
    tmp$ret$0 = Math.min(tmp0_min, tmp1_min);
    return tmp$ret$0;
  };
  protoOf(ByteRingBuffer).fu = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.math.min' call
    var tmp0_min = this.tk_1;
    var tmp1_min = this.ok_1 - (this.sk_1 & this.pk_1) | 0;
    tmp$ret$0 = Math.min(tmp0_min, tmp1_min);
    return tmp$ret$0;
  };
  protoOf(ByteRingBuffer).bl = function (consume) {
    while (consume.uk_1 > 0) {
      var tmp$ret$0;
      // Inline function 'kotlin.math.min' call
      var tmp0_min = consume.eu();
      var tmp1_min = this.fu();
      tmp$ret$0 = Math.min(tmp0_min, tmp1_min);
      var copySize = tmp$ret$0;
      arraycopy_2(consume.zt(), consume.au(), this.zt(), this.bu(), copySize);
      consume.du(copySize);
      this.cu(copySize);
    }
  };
  protoOf(ByteRingBuffer).dl = function (data, offset, size) {
    var tmp$ret$0;
    // Inline function 'kotlin.math.min' call
    var tmp0_min = this.tk_1;
    tmp$ret$0 = Math.min(tmp0_min, size);
    var remaining = tmp$ret$0;
    var coffset = offset;
    var totalWrite = 0;
    $l$loop: while (remaining > 0) {
      var tmp$ret$1;
      // Inline function 'kotlin.math.min' call
      var tmp1_min = remaining;
      var tmp2_min = this.fu();
      tmp$ret$1 = Math.min(tmp1_min, tmp2_min);
      var chunkSize = tmp$ret$1;
      if (chunkSize <= 0)
        break $l$loop;
      arraycopy_2(data, coffset, this.qk_1, this.bu(), chunkSize);
      this.cu(chunkSize);
      coffset = coffset + chunkSize | 0;
      remaining = remaining - chunkSize | 0;
      totalWrite = totalWrite + chunkSize | 0;
    }
    return totalWrite;
  };
  protoOf(ByteRingBuffer).gu = function (data, offset, size) {
    return this.fl(this.gl(data, offset, size));
  };
  protoOf(ByteRingBuffer).fl = function (size) {
    var tmp$ret$0;
    // Inline function 'kotlin.math.min' call
    var tmp0_min = this.uk_1;
    tmp$ret$0 = Math.min(tmp0_min, size);
    var toRead = tmp$ret$0;
    this.rk_1 = (this.rk_1 + toRead | 0) & this.pk_1;
    var tmp0_this = this;
    tmp0_this.tk_1 = tmp0_this.tk_1 + toRead | 0;
    var tmp1_this = this;
    tmp1_this.uk_1 = tmp1_this.uk_1 - toRead | 0;
    return toRead;
  };
  protoOf(ByteRingBuffer).gl = function (data, offset, size) {
    var tmp$ret$0;
    // Inline function 'kotlin.math.min' call
    var tmp0_min = this.uk_1;
    tmp$ret$0 = Math.min(tmp0_min, size);
    var toRead = tmp$ret$0;
    var readCount = 0;
    var buffer = this.qk_1;
    var mask = this.pk_1;
    var coffset = offset;
    var lReadPos = this.rk_1;
    $l$loop: while (true) {
      var tmp$ret$1;
      // Inline function 'kotlin.math.min' call
      var tmp1_min = toRead;
      var tmp2_min = this.eu();
      tmp$ret$1 = Math.min(tmp1_min, tmp2_min);
      var toReadChunk = tmp$ret$1;
      if (toReadChunk <= 0)
        break $l$loop;
      arraycopy_2(buffer, lReadPos & mask, data, coffset, toReadChunk);
      toRead = toRead - toReadChunk | 0;
      coffset = coffset + toReadChunk | 0;
      lReadPos = lReadPos + toReadChunk | 0;
      readCount = readCount + toReadChunk | 0;
    }
    return readCount;
  };
  protoOf(ByteRingBuffer).iu = function () {
    if (this.uk_1 <= 0)
      return -1;
    var out = this.qk_1[this.rk_1] & 255;
    this.rk_1 = (this.rk_1 + 1 | 0) & this.pk_1;
    var tmp0_this = this;
    var tmp1 = tmp0_this.uk_1;
    tmp0_this.uk_1 = tmp1 - 1 | 0;
    var tmp2_this = this;
    var tmp3 = tmp2_this.tk_1;
    tmp2_this.tk_1 = tmp3 + 1 | 0;
    return out;
  };
  protoOf(ByteRingBuffer).v2 = function () {
    this.rk_1 = 0;
    this.sk_1 = 0;
    this.uk_1 = 0;
    this.tk_1 = this.ok_1;
  };
  protoOf(ByteRingBuffer).hu = function (offset) {
    return this.qk_1[(this.rk_1 + offset | 0) & this.pk_1];
  };
  protoOf(ByteRingBuffer).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof ByteRingBuffer) {
      tmp_0 = this.uk_1 === other.uk_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'korlibs.datastructure.internal.equaler' call
        var tmp0_equaler = this.uk_1;
        var inductionVariable = 0;
        if (inductionVariable < tmp0_equaler)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp$ret$0;
            // Inline function 'korlibs.datastructure.ByteRingBuffer.equals.<anonymous>' call
            tmp$ret$0 = this.hu(n) === other.hu(n);
            if (!tmp$ret$0) {
              tmp$ret$1 = false;
              break $l$block;
            }
          }
           while (inductionVariable < tmp0_equaler);
        tmp$ret$1 = true;
      }
      tmp = tmp$ret$1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(ByteRingBuffer).hashCode = function () {
    return this.hl();
  };
  protoOf(ByteRingBuffer).hl = function () {
    var tmp$ret$1;
    // Inline function 'korlibs.datastructure.internal.hashCoder' call
    var tmp0_hashCoder = this.uk_1;
    var out = 0;
    var inductionVariable = 0;
    if (inductionVariable < tmp0_hashCoder)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out = imul(out, 7);
        var tmp = out;
        var tmp$ret$0;
        // Inline function 'korlibs.datastructure.ByteRingBuffer.contentHashCode.<anonymous>' call
        tmp$ret$0 = this.hu(n);
        out = tmp + tmp$ret$0 | 0;
      }
       while (inductionVariable < tmp0_hashCoder);
    tmp$ret$1 = out;
    return tmp$ret$1;
  };
  function _TGenStack___init__impl__yynjgt(items) {
    items = items === VOID ? FastArrayList_init_$Create$() : items;
    return items;
  }
  function _get_items__fzd5gv($this) {
    return $this;
  }
  function _TGenStack___get_size__impl__cvg66t($this) {
    return _get_items__fzd5gv($this).j();
  }
  function TGenStack__isEmpty_impl_bsbpyi($this) {
    return _TGenStack___get_size__impl__cvg66t($this) === 0;
  }
  function Companion_9() {
    Companion_instance_9 = this;
  }
  var Companion_instance_9;
  function Companion_getInstance_9() {
    if (Companion_instance_9 == null)
      new Companion_9();
    return Companion_instance_9;
  }
  function TGenStack__push_impl_9yh33t($this, v) {
    _get_items__fzd5gv($this).b(v);
  }
  function TGenStack__pop_impl_qisxa0($this) {
    return _get_items__fzd5gv($this).u2(_get_items__fzd5gv($this).j() - 1 | 0);
  }
  function TGenStack__clear_impl_pali4s($this) {
    _get_items__fzd5gv($this).v2();
  }
  function TGenStack__containsAll_impl_ic9i7r($this, elements) {
    return _get_items__fzd5gv($this).h1(elements);
  }
  function TGenStack__containsAll_impl_ic9i7r_0($this, elements) {
    return TGenStack__containsAll_impl_ic9i7r($this.ju_1, elements);
  }
  function TGenStack__iterator_impl_2pdia5($this) {
    return _get_items__fzd5gv($this).g();
  }
  function TGenStack__toString_impl_s9t5hn($this) {
    return 'TGenStack(items=' + $this + ')';
  }
  function TGenStack__hashCode_impl_l04zom($this) {
    return $this.hashCode();
  }
  function TGenStack__equals_impl_w9i35u($this, other) {
    if (!(other instanceof TGenStack))
      return false;
    var tmp0_other_with_cast = other instanceof TGenStack ? other.ju_1 : THROW_CCE();
    if (!$this.equals(tmp0_other_with_cast))
      return false;
    return true;
  }
  function TGenStack(items) {
    Companion_getInstance_9();
    this.ju_1 = items;
  }
  protoOf(TGenStack).j = function () {
    return _TGenStack___get_size__impl__cvg66t(this.ju_1);
  };
  protoOf(TGenStack).l = function () {
    return TGenStack__isEmpty_impl_bsbpyi(this.ju_1);
  };
  protoOf(TGenStack).ip = function (elements) {
    return TGenStack__containsAll_impl_ic9i7r(this.ju_1, elements);
  };
  protoOf(TGenStack).h1 = function (elements) {
    return TGenStack__containsAll_impl_ic9i7r_0(this, elements);
  };
  protoOf(TGenStack).g = function () {
    return TGenStack__iterator_impl_2pdia5(this.ju_1);
  };
  protoOf(TGenStack).toString = function () {
    return TGenStack__toString_impl_s9t5hn(this.ju_1);
  };
  protoOf(TGenStack).hashCode = function () {
    return TGenStack__hashCode_impl_l04zom(this.ju_1);
  };
  protoOf(TGenStack).equals = function (other) {
    return TGenStack__equals_impl_w9i35u(this.ju_1, other);
  };
  function Extra$PropertyThis$transform$lambda($this$null, it) {
    return it;
  }
  function Mixin(extra) {
    extra = extra === VOID ? null : extra;
    this.ku_1 = extra;
  }
  protoOf(Mixin).lu = function (_set____db54di) {
    this.ku_1 = _set____db54di;
  };
  protoOf(Mixin).mu = function () {
    return this.ku_1;
  };
  function Property(name, defaultGen) {
    name = name === VOID ? null : name;
    this.nu_1 = name;
    this.ou_1 = defaultGen;
  }
  function PropertyThis(name, defaultGen) {
    name = name === VOID ? null : name;
    this.pu_1 = name;
    this.qu_1 = defaultGen;
    var tmp = this;
    tmp.ru_1 = Extra$PropertyThis$transform$lambda;
  }
  function getExtra(_this__u8e3s4, name) {
    var tmp0_safe_receiver = _this__u8e3s4.mu();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp$ret$1;
      // Inline function 'korlibs.datastructure.get' call
      var tmp$ret$0;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$0 = tmp0_safe_receiver;
      tmp$ret$1 = tmp$ret$0.get(name);
      tmp = tmp$ret$1;
    }
    return tmp;
  }
  function setExtra(_this__u8e3s4, name, value) {
    if (_this__u8e3s4.mu() == null) {
      if (value == null)
        return Unit_getInstance();
      _this__u8e3s4.lu(ExtraTypeCreate());
    }
    var tmp0_safe_receiver = _this__u8e3s4.mu();
    if (tmp0_safe_receiver == null)
      null;
    else {
      var tmp$ret$2;
      // Inline function 'korlibs.datastructure.set' call
      var tmp$ret$1;
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp$ret$0;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$0 = tmp0_safe_receiver;
      tmp$ret$1 = tmp$ret$0.set(name, value);
      tmp$ret$2 = tmp$ret$1;
    }
  }
  function hasExtra(_this__u8e3s4, name) {
    var tmp0_safe_receiver = _this__u8e3s4.mu();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp$ret$1;
      // Inline function 'korlibs.datastructure.contains' call
      var tmp$ret$0;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$0 = tmp0_safe_receiver;
      tmp$ret$1 = tmp$ret$0.has(name);
      tmp = tmp$ret$1;
    }
    return tmp === true;
  }
  function getExtraTyped(_this__u8e3s4, name) {
    var tmp$ret$4;
    // Inline function 'korlibs.datastructure.fastCastTo' call
    var tmp0_safe_receiver = _this__u8e3s4.mu();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp$ret$1;
      // Inline function 'korlibs.datastructure.get' call
      var tmp$ret$0;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$0 = tmp0_safe_receiver;
      tmp$ret$1 = tmp$ret$0.get(name);
      tmp = tmp$ret$1;
    }
    var tmp0_fastCastTo = tmp;
    var tmp$ret$3;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$2;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$2 = tmp0_fastCastTo;
    tmp$ret$3 = tmp$ret$2;
    tmp$ret$4 = tmp$ret$3;
    return tmp$ret$4;
  }
  function ExtraTypeCreate() {
    return FastStringMap();
  }
  function linkedHashMapOf(pairs) {
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.linkedHashMapOf.<anonymous>' call
    var indexedObject = pairs;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var tmp1_loop_parameter = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var key = tmp1_loop_parameter.v3();
      var value = tmp1_loop_parameter.w3();
      // Inline function 'kotlin.collections.set' call
      tmp0_also.x3(key, value);
    }
    tmp$ret$0 = tmp0_also;
    return tmp$ret$0;
  }
  function _BSearchResult___init__impl__em6zam(raw) {
    return raw;
  }
  function _BSearchResult___get_raw__impl__uyuhf3($this) {
    return $this;
  }
  function _BSearchResult___get_found__impl__om04iz($this) {
    return _BSearchResult___get_raw__impl__uyuhf3($this) >= 0;
  }
  function _BSearchResult___get_index__impl__b5kraz($this) {
    return _BSearchResult___get_found__impl__om04iz($this) ? _BSearchResult___get_raw__impl__uyuhf3($this) : -1;
  }
  function _BSearchResult___get_nearIndex__impl__s8nq43($this) {
    return _BSearchResult___get_found__impl__om04iz($this) ? _BSearchResult___get_raw__impl__uyuhf3($this) : (-_BSearchResult___get_raw__impl__uyuhf3($this) | 0) - 1 | 0;
  }
  function binarySearch(_this__u8e3s4, v, fromIndex, toIndex) {
    fromIndex = fromIndex === VOID ? 0 : fromIndex;
    toIndex = toIndex === VOID ? _this__u8e3s4.j() : toIndex;
    var tmp$ret$3;
    // Inline function 'korlibs.datastructure.genericBinarySearchResult' call
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.datastructure.genericBinarySearch' call
      var low = fromIndex;
      var high = toIndex - 1 | 0;
      while (low <= high) {
        var mid = (low + high | 0) / 2 | 0;
        var tmp$ret$0;
        // Inline function 'korlibs.datastructure.binarySearch.<anonymous>' call
        tmp$ret$0 = compareTo(_this__u8e3s4.ek(mid), v);
        var mval = tmp$ret$0;
        if (mval < 0)
          low = mid + 1 | 0;
        else if (mval > 0)
          high = mid - 1 | 0;
        else {
          tmp$ret$1 = mid;
          break $l$block;
        }
      }
      var tmp$ret$2;
      // Inline function 'korlibs.datastructure.genericBinarySearchResult.<anonymous>' call
      var tmp0__anonymous__q1qw7t = low;
      var tmp1__anonymous__uwfjfc = high;
      tmp$ret$2 = (-tmp0__anonymous__q1qw7t | 0) - 1 | 0;
      tmp$ret$1 = tmp$ret$2;
    }
    tmp$ret$3 = _BSearchResult___init__impl__em6zam(tmp$ret$1);
    return tmp$ret$3;
  }
  function getCyclic(_this__u8e3s4, index) {
    return _this__u8e3s4.k(umod(index, _this__u8e3s4.j()));
  }
  function binarySearch_0(_this__u8e3s4, v, fromIndex, toIndex) {
    fromIndex = fromIndex === VOID ? 0 : fromIndex;
    toIndex = toIndex === VOID ? _this__u8e3s4.j() : toIndex;
    var tmp$ret$3;
    // Inline function 'korlibs.datastructure.genericBinarySearchResult' call
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.datastructure.genericBinarySearch' call
      var low = fromIndex;
      var high = toIndex - 1 | 0;
      while (low <= high) {
        var mid = (low + high | 0) / 2 | 0;
        var tmp$ret$0;
        // Inline function 'korlibs.datastructure.binarySearch.<anonymous>' call
        tmp$ret$0 = compareTo(_this__u8e3s4.ek(mid), v);
        var mval = tmp$ret$0;
        if (mval < 0)
          low = mid + 1 | 0;
        else if (mval > 0)
          high = mid - 1 | 0;
        else {
          tmp$ret$1 = mid;
          break $l$block;
        }
      }
      var tmp$ret$2;
      // Inline function 'korlibs.datastructure.genericBinarySearchResult.<anonymous>' call
      var tmp0__anonymous__q1qw7t = low;
      var tmp1__anonymous__uwfjfc = high;
      tmp$ret$2 = (-tmp0__anonymous__q1qw7t | 0) - 1 | 0;
      tmp$ret$1 = tmp$ret$2;
    }
    tmp$ret$3 = _BSearchResult___init__impl__em6zam(tmp$ret$1);
    return tmp$ret$3;
  }
  function toLinkedMap(_this__u8e3s4) {
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.toLinkedMap.<anonymous>' call
    var tmp0_iterator = _this__u8e3s4.g();
    while (tmp0_iterator.h()) {
      var tmp1_loop_parameter = tmp0_iterator.i();
      var key = tmp1_loop_parameter.v3();
      var value = tmp1_loop_parameter.w3();
      // Inline function 'kotlin.collections.set' call
      tmp0_also.x3(key, value);
    }
    tmp$ret$0 = tmp0_also;
    return tmp$ret$0;
  }
  function flip(_this__u8e3s4) {
    var tmp$ret$3;
    // Inline function 'kotlin.collections.map' call
    var tmp$ret$2;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList_init_$Create$(_this__u8e3s4.j());
    var tmp$ret$0;
    // Inline function 'kotlin.collections.iterator' call
    tmp$ret$0 = _this__u8e3s4.o().g();
    var tmp0_iterator = tmp$ret$0;
    while (tmp0_iterator.h()) {
      var item = tmp0_iterator.i();
      var tmp$ret$1;
      // Inline function 'korlibs.datastructure.flip.<anonymous>' call
      tmp$ret$1 = new Pair(item.q(), item.p());
      tmp0_mapTo.b(tmp$ret$1);
    }
    tmp$ret$2 = tmp0_mapTo;
    tmp$ret$3 = tmp$ret$2;
    return toMap(tmp$ret$3);
  }
  function getCyclic_0(_this__u8e3s4, index) {
    return _this__u8e3s4[umod(index, _this__u8e3s4.length)];
  }
  function genericSort(subject, left, right, ops) {
    return genericSort_0(subject, left, right, ops, false);
  }
  function SortOps() {
  }
  protoOf(SortOps).ko = function (subject, indexL, indexR) {
    var inductionVariable = indexR;
    var last = indexL + 1 | 0;
    if (last <= inductionVariable)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        this.jo(subject, n - 1 | 0, n);
      }
       while (!(n === last));
  };
  protoOf(SortOps).fo = function (subject, indexL, indexR) {
    var count = (indexR - indexL | 0) + 1 | 0;
    var inductionVariable = 0;
    var last = count / 2 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.jo(subject, indexL + n | 0, indexR - n | 0);
      }
       while (inductionVariable < last);
  };
  function genericSort_0(subject, left, right, ops, reversed) {
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.genericSort.<anonymous>' call
    timSort(subject, left, right, ops, reversed);
    tmp$ret$0 = subject;
    return tmp$ret$0;
  }
  function timSort(arr, l, r, ops, reversed, RUN) {
    RUN = RUN === VOID ? 32 : RUN;
    var n = (r - l | 0) + 1 | 0;
    var progression = step(until(0, n), RUN);
    var inductionVariable = progression.a1_1;
    var last = progression.b1_1;
    var step_0 = progression.c1_1;
    if ((step_0 > 0 ? inductionVariable <= last : false) ? true : step_0 < 0 ? last <= inductionVariable : false)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        var tmp = l + i | 0;
        var tmp$ret$0;
        // Inline function 'kotlin.math.min' call
        var tmp0_min = (i + RUN | 0) - 1 | 0;
        var tmp1_min = n - 1 | 0;
        tmp$ret$0 = Math.min(tmp0_min, tmp1_min);
        insertionSort(arr, tmp, l + tmp$ret$0 | 0, ops, reversed);
      }
       while (!(i === last));
    var size = RUN;
    while (size < n) {
      var progression_0 = step(until(0, n), imul(2, size));
      var inductionVariable_0 = progression_0.a1_1;
      var last_0 = progression_0.b1_1;
      var step_1 = progression_0.c1_1;
      if ((step_1 > 0 ? inductionVariable_0 <= last_0 : false) ? true : step_1 < 0 ? last_0 <= inductionVariable_0 : false)
        do {
          var left = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + step_1 | 0;
          var tmp$ret$1;
          // Inline function 'kotlin.math.min' call
          var tmp2_min = size;
          var tmp3_min = (n - left | 0) - 1 | 0;
          tmp$ret$1 = Math.min(tmp2_min, tmp3_min);
          var rize = tmp$ret$1;
          var mid = (left + rize | 0) - 1 | 0;
          var tmp$ret$2;
          // Inline function 'kotlin.math.min' call
          var tmp4_min = (left + imul(2, rize) | 0) - 1 | 0;
          var tmp5_min = n - 1 | 0;
          tmp$ret$2 = Math.min(tmp4_min, tmp5_min);
          var right = tmp$ret$2;
          merge(arr, l + left | 0, l + mid | 0, l + right | 0, ops, reversed);
        }
         while (!(left === last_0));
      size = imul(size, 2);
    }
  }
  function insertionSort(arr, left, right, ops, reversed) {
    var inductionVariable = left + 1 | 0;
    if (inductionVariable <= right)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var m = n - 1 | 0;
        $l$loop: while (m >= left) {
          if (negateIf(ops.ho(arr, m, n), reversed) <= 0)
            break $l$loop;
          var tmp1 = m;
          m = tmp1 - 1 | 0;
        }
        var tmp2 = m;
        m = tmp2 + 1 | 0;
        if (!(m === n)) {
          ops.ko(arr, m, n);
        }
      }
       while (!(n === right));
  }
  function merge(arr, start, mid, end, ops, reversed) {
    var s = start;
    var m = mid;
    var s2 = m + 1 | 0;
    if (negateIf(ops.ho(arr, m, s2), reversed) <= 0)
      return Unit_getInstance();
    while (s <= m ? s2 <= end : false) {
      if (negateIf(ops.ho(arr, s, s2), reversed) <= 0) {
        var tmp0 = s;
        s = tmp0 + 1 | 0;
      } else {
        ops.ko(arr, s, s2);
        var tmp1 = s;
        s = tmp1 + 1 | 0;
        var tmp2 = m;
        m = tmp2 + 1 | 0;
        var tmp3 = s2;
        s2 = tmp3 + 1 | 0;
      }
    }
  }
  function negateIf(_this__u8e3s4, doNegate) {
    return doNegate ? -_this__u8e3s4 | 0 : _this__u8e3s4;
  }
  function umod(_this__u8e3s4, other) {
    var remainder = _this__u8e3s4 % other | 0;
    return remainder < 0 ? remainder + other | 0 : remainder;
  }
  function ilog2Ceil(v) {
    var tmp$ret$1;
    // Inline function 'kotlin.math.ceil' call
    var tmp$ret$0;
    // Inline function 'kotlin.math.log2' call
    var tmp0_log2 = v;
    tmp$ret$0 = log2(tmp0_log2);
    var tmp1_ceil = tmp$ret$0;
    tmp$ret$1 = Math.ceil(tmp1_ceil);
    return numberToInt(tmp$ret$1);
  }
  function fill(_this__u8e3s4, value) {
    var inductionVariable = 0;
    var last = _this__u8e3s4.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        _this__u8e3s4[n] = value;
      }
       while (inductionVariable < last);
  }
  function arraycopy(src, srcPos, dst, dstPos, size) {
    var tmp$ret$4;
    // Inline function 'kotlin.collections.copyInto' call
    var tmp0_copyInto = srcPos + size | 0;
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = src;
    tmp$ret$1 = tmp$ret$0;
    var tmp = tmp$ret$1;
    var tmp$ret$3;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$2;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$2 = dst;
    tmp$ret$3 = tmp$ret$2;
    arrayCopy(tmp, tmp$ret$3, dstPos, srcPos, tmp0_copyInto);
    tmp$ret$4 = dst;
    return tmp$ret$4;
  }
  function contentHashCode_2(_this__u8e3s4, src, dst) {
    var tmp$ret$1;
    // Inline function 'korlibs.datastructure.internal.hashCoder' call
    var tmp0_hashCoder = dst - src | 0;
    var out = 0;
    var inductionVariable = 0;
    if (inductionVariable < tmp0_hashCoder)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out = imul(out, 7);
        var tmp = out;
        var tmp$ret$0;
        // Inline function 'korlibs.datastructure.internal.contentHashCode.<anonymous>' call
        tmp$ret$0 = numberToInt(_this__u8e3s4[src + n | 0]);
        out = tmp + tmp$ret$0 | 0;
      }
       while (inductionVariable < tmp0_hashCoder);
    tmp$ret$1 = out;
    return tmp$ret$1;
  }
  function contentEquals_2(_this__u8e3s4, that, src, dst) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.datastructure.internal.equaler' call
      var tmp0_equaler = dst - src | 0;
      var inductionVariable = 0;
      if (inductionVariable < tmp0_equaler)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp$ret$0;
          // Inline function 'korlibs.datastructure.internal.contentEquals.<anonymous>' call
          tmp$ret$0 = _this__u8e3s4[src + n | 0] === that[src + n | 0];
          if (!tmp$ret$0) {
            tmp$ret$1 = false;
            break $l$block;
          }
        }
         while (inductionVariable < tmp0_equaler);
      tmp$ret$1 = true;
    }
    return tmp$ret$1;
  }
  function arraycopy_0(src, srcPos, dst, dstPos, size) {
    var tmp$ret$4;
    // Inline function 'kotlin.collections.copyInto' call
    var tmp0_copyInto = srcPos + size | 0;
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = src;
    tmp$ret$1 = tmp$ret$0;
    var tmp = tmp$ret$1;
    var tmp$ret$3;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$2;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$2 = dst;
    tmp$ret$3 = tmp$ret$2;
    arrayCopy(tmp, tmp$ret$3, dstPos, srcPos, tmp0_copyInto);
    tmp$ret$4 = dst;
    return tmp$ret$4;
  }
  function contentHashCode_3(_this__u8e3s4, src, dst) {
    var tmp$ret$1;
    // Inline function 'korlibs.datastructure.internal.hashCoder' call
    var tmp0_hashCoder = dst - src | 0;
    var out = 0;
    var inductionVariable = 0;
    if (inductionVariable < tmp0_hashCoder)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out = imul(out, 7);
        var tmp = out;
        var tmp$ret$0;
        // Inline function 'korlibs.datastructure.internal.contentHashCode.<anonymous>' call
        tmp$ret$0 = toRawBits(_this__u8e3s4[src + n | 0]);
        out = tmp + tmp$ret$0 | 0;
      }
       while (inductionVariable < tmp0_hashCoder);
    tmp$ret$1 = out;
    return tmp$ret$1;
  }
  function contentEquals_3(_this__u8e3s4, that, src, dst) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.datastructure.internal.equaler' call
      var tmp0_equaler = dst - src | 0;
      var inductionVariable = 0;
      if (inductionVariable < tmp0_equaler)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp$ret$0;
          // Inline function 'korlibs.datastructure.internal.contentEquals.<anonymous>' call
          tmp$ret$0 = _this__u8e3s4[src + n | 0] === that[src + n | 0];
          if (!tmp$ret$0) {
            tmp$ret$1 = false;
            break $l$block;
          }
        }
         while (inductionVariable < tmp0_equaler);
      tmp$ret$1 = true;
    }
    return tmp$ret$1;
  }
  function arraycopy_1(src, srcPos, dst, dstPos, size) {
    var tmp$ret$4;
    // Inline function 'kotlin.collections.copyInto' call
    var tmp0_copyInto = srcPos + size | 0;
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = src;
    tmp$ret$1 = tmp$ret$0;
    var tmp = tmp$ret$1;
    var tmp$ret$3;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$2;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$2 = dst;
    tmp$ret$3 = tmp$ret$2;
    arrayCopy(tmp, tmp$ret$3, dstPos, srcPos, tmp0_copyInto);
    tmp$ret$4 = dst;
    return tmp$ret$4;
  }
  function contentHashCode_4(_this__u8e3s4, src, dst) {
    var tmp$ret$1;
    // Inline function 'korlibs.datastructure.internal.hashCoder' call
    var tmp0_hashCoder = dst - src | 0;
    var out = 0;
    var inductionVariable = 0;
    if (inductionVariable < tmp0_hashCoder)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out = imul(out, 7);
        var tmp = out;
        var tmp$ret$0;
        // Inline function 'korlibs.datastructure.internal.contentHashCode.<anonymous>' call
        tmp$ret$0 = _this__u8e3s4[src + n | 0];
        out = tmp + tmp$ret$0 | 0;
      }
       while (inductionVariable < tmp0_hashCoder);
    tmp$ret$1 = out;
    return tmp$ret$1;
  }
  function contentEquals_4(_this__u8e3s4, that, src, dst) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.datastructure.internal.equaler' call
      var tmp0_equaler = dst - src | 0;
      var inductionVariable = 0;
      if (inductionVariable < tmp0_equaler)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp$ret$0;
          // Inline function 'korlibs.datastructure.internal.contentEquals.<anonymous>' call
          tmp$ret$0 = _this__u8e3s4[src + n | 0] === that[src + n | 0];
          if (!tmp$ret$0) {
            tmp$ret$1 = false;
            break $l$block;
          }
        }
         while (inductionVariable < tmp0_equaler);
      tmp$ret$1 = true;
    }
    return tmp$ret$1;
  }
  function arraycopy_2(src, srcPos, dst, dstPos, size) {
    var tmp$ret$4;
    // Inline function 'kotlin.collections.copyInto' call
    var tmp0_copyInto = srcPos + size | 0;
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = src;
    tmp$ret$1 = tmp$ret$0;
    var tmp = tmp$ret$1;
    var tmp$ret$3;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$2;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$2 = dst;
    tmp$ret$3 = tmp$ret$2;
    arrayCopy(tmp, tmp$ret$3, dstPos, srcPos, tmp0_copyInto);
    tmp$ret$4 = dst;
    return tmp$ret$4;
  }
  function ilog2(v) {
    var tmp$ret$0;
    // Inline function 'kotlin.math.log2' call
    var tmp0_log2 = v;
    tmp$ret$0 = log2(tmp0_log2);
    return numberToInt(tmp$ret$0);
  }
  function arraycopy_3(src, srcPos, dst, dstPos, size) {
    var tmp$ret$0;
    // Inline function 'kotlin.collections.copyInto' call
    var tmp0_copyInto = srcPos + size | 0;
    arrayCopy(src, dst, dstPos, srcPos, tmp0_copyInto);
    tmp$ret$0 = dst;
    return tmp$ret$0;
  }
  function FastArrayList_init_$Init$($this) {
    var tmp$ret$0;
    // Inline function 'kotlin.emptyArray' call
    tmp$ret$0 = [];
    FastArrayList.call($this, tmp$ret$0);
    return $this;
  }
  function FastArrayList_init_$Create$() {
    return FastArrayList_init_$Init$(objectCreate(protoOf(FastArrayList)));
  }
  function FastArrayList_init_$Init$_0(initialCapacity, $this) {
    initialCapacity = initialCapacity === VOID ? 0 : initialCapacity;
    var tmp$ret$0;
    // Inline function 'kotlin.emptyArray' call
    tmp$ret$0 = [];
    FastArrayList.call($this, tmp$ret$0);
    return $this;
  }
  function FastArrayList_init_$Create$_0(initialCapacity) {
    return FastArrayList_init_$Init$_0(initialCapacity, objectCreate(protoOf(FastArrayList)));
  }
  function _addAll($this, elements) {
    var tmp$ret$0;
    // Inline function 'kotlin.collections.isEmpty' call
    tmp$ret$0 = elements.length === 0;
    if (tmp$ret$0)
      return false;
    var tmp$ret$3;
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    var tmp$ret$2;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = $this.vp_1;
    var tmp$ret$1;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$1 = tmp0_unsafeCast;
    tmp$ret$2 = tmp$ret$1;
    tmp$ret$3 = tmp$ret$2;
    (function () {
      var $externalVarargReceiverTmp = tmp$ret$3;
      return $externalVarargReceiverTmp.push.apply($externalVarargReceiverTmp, [].slice.call(elements.slice()));
    }.call(this));
    var tmp0_this = $this;
    var tmp1 = tmp0_this.y2_1;
    tmp0_this.y2_1 = tmp1 + 1 | 0;
    return true;
  }
  function rangeCheck($this, index) {
    if (index < 0 ? true : index >= $this.j())
      throw IndexOutOfBoundsException_init_$Create$_0('index: ' + index + ', size: ' + $this.j());
    return index;
  }
  function insertionRangeCheck($this, index) {
    if (index < 0 ? true : index > $this.j())
      throw IndexOutOfBoundsException_init_$Create$_0('index: ' + index + ', size: ' + $this.j());
    return index;
  }
  function FastArrayList(__array) {
    AbstractMutableList.call(this);
    this.vp_1 = __array;
  }
  protoOf(FastArrayList).j = function () {
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = this.vp_1;
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_unsafeCast;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    return tmp$ret$2.length;
  };
  protoOf(FastArrayList).k = function (index) {
    var tmp$ret$4;
    // Inline function 'korlibs.datastructure.get' call
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = this.vp_1;
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_unsafeCast;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    var tmp1_get = tmp$ret$2;
    var tmp2_get = rangeCheck(this, index);
    var tmp$ret$3;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$3 = tmp1_get;
    tmp$ret$4 = tmp$ret$3[tmp2_get];
    return tmp$ret$4;
  };
  protoOf(FastArrayList).r2 = function (index, element) {
    rangeCheck(this, index);
    var tmp$ret$9;
    // Inline function 'kotlin.apply' call
    var tmp$ret$4;
    // Inline function 'korlibs.datastructure.get' call
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = this.vp_1;
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_unsafeCast;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    var tmp1_get = tmp$ret$2;
    var tmp$ret$3;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$3 = tmp1_get;
    tmp$ret$4 = tmp$ret$3[index];
    var tmp2_apply = tmp$ret$4;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.FastArrayList.set.<anonymous>' call
    // Inline function 'korlibs.datastructure.set' call
    var tmp$ret$7;
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    var tmp$ret$6;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast_0 = this.vp_1;
    var tmp$ret$5;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$5 = tmp0_unsafeCast_0;
    tmp$ret$6 = tmp$ret$5;
    tmp$ret$7 = tmp$ret$6;
    var tmp1_set = tmp$ret$7;
    var tmp$ret$8;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$8 = tmp1_set;
    tmp$ret$8[index] = element;
    tmp$ret$9 = tmp2_apply;
    return tmp$ret$9;
  };
  protoOf(FastArrayList).b = function (element) {
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = this.vp_1;
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_unsafeCast;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    tmp$ret$2.push(element);
    var tmp0_this = this;
    var tmp1 = tmp0_this.y2_1;
    tmp0_this.y2_1 = tmp1 + 1 | 0;
    return true;
  };
  protoOf(FastArrayList).q2 = function (index, element) {
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = this.vp_1;
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_unsafeCast;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    tmp$ret$2.splice(insertionRangeCheck(this, index), 0, element);
    var tmp0_this = this;
    var tmp1 = tmp0_this.y2_1;
    tmp0_this.y2_1 = tmp1 + 1 | 0;
  };
  protoOf(FastArrayList).m = function (elements) {
    var tmp$ret$0;
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp$ret$0 = copyToArray(elements);
    return _addAll(this, tmp$ret$0);
  };
  protoOf(FastArrayList).u2 = function (index) {
    rangeCheck(this, index);
    var tmp0_this = this;
    var tmp1 = tmp0_this.y2_1;
    tmp0_this.y2_1 = tmp1 + 1 | 0;
    var tmp2_subject = index;
    var tmp;
    if (tmp2_subject === 0) {
      var tmp$ret$2;
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      var tmp$ret$1;
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp0_unsafeCast = this.vp_1;
      var tmp$ret$0;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$0 = tmp0_unsafeCast;
      tmp$ret$1 = tmp$ret$0;
      tmp$ret$2 = tmp$ret$1;
      tmp = tmp$ret$2.shift();
    } else if (tmp2_subject === get_lastIndex(this)) {
      var tmp$ret$5;
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      var tmp$ret$4;
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp1_unsafeCast = this.vp_1;
      var tmp$ret$3;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$3 = tmp1_unsafeCast;
      tmp$ret$4 = tmp$ret$3;
      tmp$ret$5 = tmp$ret$4;
      tmp = tmp$ret$5.pop();
    } else {
      var tmp$ret$10;
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$8;
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      var tmp$ret$7;
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp2_unsafeCast = this.vp_1;
      var tmp$ret$6;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$6 = tmp2_unsafeCast;
      tmp$ret$7 = tmp$ret$6;
      tmp$ret$8 = tmp$ret$7;
      var tmp3_unsafeCast = tmp$ret$8.splice(index, 1);
      var tmp$ret$9;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$9 = tmp3_unsafeCast;
      tmp$ret$10 = tmp$ret$9;
      tmp = tmp$ret$10[0];
    }
    return tmp;
  };
  protoOf(FastArrayList).t2 = function (element) {
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = this.vp_1;
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_unsafeCast;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    var array = tmp$ret$2;
    var inductionVariable = 0;
    var last = array.length;
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$4;
        // Inline function 'korlibs.datastructure.get' call
        var tmp$ret$3;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$3 = array;
        tmp$ret$4 = tmp$ret$3[index];
        if (equals(tmp$ret$4, element)) {
          array.splice(index, 1);
          var tmp1_this = this;
          var tmp2 = tmp1_this.y2_1;
          tmp1_this.y2_1 = tmp2 + 1 | 0;
          return true;
        }
      }
       while (inductionVariable < last);
    return false;
  };
  protoOf(FastArrayList).a3 = function (fromIndex, toIndex) {
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = this.vp_1;
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_unsafeCast;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    tmp$ret$2.splice(fromIndex, toIndex - fromIndex | 0);
    var tmp0_this = this;
    var tmp1 = tmp0_this.y2_1;
    tmp0_this.y2_1 = tmp1 + 1 | 0;
  };
  protoOf(FastArrayList).v2 = function () {
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = this.vp_1;
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_unsafeCast;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    tmp$ret$2.length = 0;
    var tmp0_this = this;
    var tmp1 = tmp0_this.y2_1;
    tmp0_this.y2_1 = tmp1 + 1 | 0;
  };
  protoOf(FastArrayList).s2 = function (element) {
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = this.vp_1;
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_unsafeCast;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    return tmp$ret$2.indexOf(element);
  };
  protoOf(FastArrayList).toString = function () {
    var tmp$ret$4;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = this.vp_1;
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_unsafeCast;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    var tmp1_unsafeCast = tmp$ret$2;
    var tmp$ret$3;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$3 = tmp1_unsafeCast;
    tmp$ret$4 = tmp$ret$3;
    return '[' + joinToString_0(tmp$ret$4, ', ') + ']';
  };
  protoOf(FastArrayList).x2 = function () {
    var tmp$ret$4;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = this.vp_1;
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_unsafeCast;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    var tmp1_unsafeCast = tmp$ret$2.concat();
    var tmp$ret$3;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$3 = tmp1_unsafeCast;
    tmp$ret$4 = tmp$ret$3;
    return tmp$ret$4;
  };
  protoOf(FastArrayList).toArray = function () {
    return this.x2();
  };
  function FastStringMap() {
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0_asDynamic = new Map();
    tmp$ret$0 = tmp0_asDynamic;
    return tmp$ret$0;
  }
  function FastIntMap() {
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0_asDynamic = new Map();
    tmp$ret$0 = tmp0_asDynamic;
    return tmp$ret$0;
  }
  function get_size(_this__u8e3s4) {
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = _this__u8e3s4;
    return tmp$ret$0.size;
  }
  function FastIdentityMap() {
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0_asDynamic = new Map();
    tmp$ret$0 = tmp0_asDynamic;
    return tmp$ret$0;
  }
  function clear(_this__u8e3s4) {
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = _this__u8e3s4;
    tmp$ret$0.clear();
  }
  function contains(_this__u8e3s4, key) {
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = _this__u8e3s4;
    return tmp$ret$0.has(key);
  }
  function get_size_0(_this__u8e3s4) {
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = _this__u8e3s4;
    return tmp$ret$0.size;
  }
  function get(_this__u8e3s4, key) {
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = _this__u8e3s4;
    return tmp$ret$0.get(key);
  }
  function set(_this__u8e3s4, key, value) {
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = _this__u8e3s4;
    tmp$ret$0.set(key, value);
  }
  function remove(_this__u8e3s4, key) {
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = _this__u8e3s4;
    tmp$ret$0.delete(key);
  }
  function keys(_this__u8e3s4) {
    var tmp$ret$2;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = _this__u8e3s4;
    var tmp0_unsafeCast = Array_from(tmp$ret$0.keys());
    var tmp$ret$1;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$1 = tmp0_unsafeCast;
    tmp$ret$2 = tmp$ret$1;
    return toList_0(tmp$ret$2);
  }
  function Array_from(value) {
    return Array.from(value);
  }
  var CONCURRENCY_COUNT;
  function NonRecursiveLock() {
  }
  function Lock() {
  }
  //region block: post-declaration
  protoOf(IntArray2).ik = getAt;
  protoOf(IntArray2).hk = asString;
  protoOf(FloatArray2).ik = getAt;
  protoOf(FloatArray2).hk = asString;
  protoOf(FastArrayList).zp = addAll_0;
  protoOf(FastArrayList).xp = setAddAll;
  protoOf(FastArrayList).tp = setAddAll$default;
  protoOf(FastArrayList).yp = setAll;
  protoOf(FastArrayList).wp = removeToSize;
  //endregion
  //region block: init
  CONCURRENCY_COUNT = 1;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = FastArrayList_init_$Create$_0;
  _.$_$.b = FastArrayList_init_$Create$;
  _.$_$.c = FloatArrayList_init_$Create$;
  _.$_$.d = IntArrayList_init_$Create$;
  _.$_$.e = IntIntMap_init_$Create$;
  _.$_$.f = IntMap_init_$Create$;
  _.$_$.g = Pool_init_$Create$;
  _.$_$.h = _BSearchResult___init__impl__em6zam;
  _.$_$.i = _BSearchResult___get_found__impl__om04iz;
  _.$_$.j = _BSearchResult___get_index__impl__b5kraz;
  _.$_$.k = _BSearchResult___get_nearIndex__impl__s8nq43;
  _.$_$.l = _TGenStack___init__impl__yynjgt;
  _.$_$.m = TGenStack__pop_impl_qisxa0;
  _.$_$.n = TGenStack__push_impl_9yh33t;
  _.$_$.o = Companion_getInstance_0;
  _.$_$.p = Companion_getInstance;
  _.$_$.q = Companion_getInstance_8;
  _.$_$.r = Lock;
  _.$_$.s = NonRecursiveLock;
  _.$_$.t = ByteArrayDeque;
  _.$_$.u = ConcurrentPool;
  _.$_$.v = DoubleArrayList;
  _.$_$.w = Mixin;
  _.$_$.x = PropertyThis;
  _.$_$.y = Property;
  _.$_$.z = FastIdentityMap;
  _.$_$.a1 = FastIntMap;
  _.$_$.b1 = FastSmallSet;
  _.$_$.c1 = FastStringMap;
  _.$_$.d1 = FloatArray2;
  _.$_$.e1 = FloatArrayDeque;
  _.$_$.f1 = FloatArrayList;
  _.$_$.g1 = GenericListIterator;
  _.$_$.h1 = IntArray2;
  _.$_$.i1 = IntArrayList;
  _.$_$.j1 = IntDeque;
  _.$_$.k1 = ListReader;
  _.$_$.l1 = Pool;
  _.$_$.m1 = Ref_0;
  _.$_$.n1 = Ref;
  _.$_$.o1 = ReturnablePool;
  _.$_$.p1 = RingBuffer;
  _.$_$.q1 = ShortArrayDeque;
  _.$_$.r1 = SortOps;
  _.$_$.s1 = TGenQueue;
  _.$_$.t1 = associateByInt;
  _.$_$.u1 = binarySearch;
  _.$_$.v1 = binarySearch_0;
  _.$_$.w1 = clear;
  _.$_$.x1 = contains;
  _.$_$.y1 = fastArrayListOf;
  _.$_$.z1 = flip;
  _.$_$.a2 = floatArrayListOf;
  _.$_$.b2 = genericSort;
  _.$_$.c2 = getAndRemove;
  _.$_$.d2 = getCyclic_0;
  _.$_$.e2 = getCyclic;
  _.$_$.f2 = getExtraTyped;
  _.$_$.g2 = getExtra;
  _.$_$.h2 = get;
  _.$_$.i2 = hasExtra;
  _.$_$.j2 = intArrayListOf;
  _.$_$.k2 = get_keys;
  _.$_$.l2 = linkedHashMapOf;
  _.$_$.m2 = reverse_0;
  _.$_$.n2 = rotateRight;
  _.$_$.o2 = setExtra;
  _.$_$.p2 = set;
  _.$_$.q2 = get_size;
  _.$_$.r2 = sort;
  _.$_$.s2 = swap;
  _.$_$.t2 = toCaseInsensitiveMap;
  _.$_$.u2 = toFastList;
  _.$_$.v2 = toFastList_0;
  _.$_$.w2 = toIntArrayList;
  _.$_$.x2 = toIntMap;
  _.$_$.y2 = toMap_0;
  _.$_$.z2 = toRef;
  //endregion
  return _;
}));
